import { Component, OnInit, Inject, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../../services/global.service';
import { MatDialog } from '@angular/material/dialog';
import { BasicQuestionComponent } from '../../../shared/modal/basic-question/basic-question.component';
import { DISABLED } from '@angular/forms/src/model';
import Utils from '../../../shared/utility';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-adjust-desired-claim-age',
  templateUrl: './adjust-desired-claim-age.component.html',
  styleUrls: ['./adjust-desired-claim-age.component.css']
})
export class AdjustDesiredClaimAgeComponent implements OnInit {
  
  adjustDesiredForm: FormGroup;
  minYearOne;
  maxYear;
  data;
  dataFromModalAdjust;
  minClaimAge: number = 62;
  maxClaimAge: number = 70;
  minSurvivorSwitchMonths: number = 0;
  minFileRestrictedMonths: number = 0;
  spouseMinClaimAge: number = 62;
  spouseMaxClaimAge: number = 70;
  minSurvivorSwitchClaimAge: number = 62;
  maxSurvivorSwitchClaimAge: number = 70;
  minSpouseSurvivorSwitchClaimAge: number = 62;
  maxSpouseSurvivorSwitchClaimAge: number = 70;
  minFileRestrictedClaimAge: number = 69;
  minFileRestrictedClaimMonths: number = 0;
  minSpouseFileRestrictedClaimMonths: number = 0;
  minRetroFileClaimAge: number = 0;
  minRetroFileClaimMonths: number = 0;
  minSpouseRetroFileClaimAge: number = 0;
  minSpouseRetroFileClaimMonths: number = 0;
  isDivorceCaseMeet: boolean = false;
  isShowSurvivorSection: boolean = false;
  isClientFilingRestricted: boolean = false;
  isSpouseFilingRestricted: boolean = false;
  isClientAgeReadOnly: boolean = true;
  isSpouseAgeReadOnly: boolean = false;
  scenario;
  isSurvivorBenefitFirstClaim: boolean = false;
  isSpouseSurvivorBenefitFirstClaim: boolean = false;
  clientFRAYears: number;
  clientFRAMonths: number;
  spouseFRAYears: number;
  spouseFRAMonths: number;
  maxSurvivorSwitchClaimMonths: number = 11;
  minSurvivorSwitchClaimMonths: number = 0;
  maxSpouseSurvivorSwitchClaimMonths: number = 11;
  minSpouseSurvivorSwitchClaimMonths: number = 0;
  maxClientClaimMonths: number = 11;
  minClientClaimMonths: number = 0;
  maxSpouseClaimMonths: number = 11;
  minSpouseClaimMonths: number = 0;
  isFRAAlt: boolean = false;
  isClientRetroFiling: boolean = false;
  isSpouseRetroFiling: boolean = false;
  isSurvivorForClient: boolean = true;
  mostProfitableSpouse;

  clientAlreadyClaiming: boolean = false;
  spouseAlreadyClaiming: boolean = false;
  hidePointerEventStyling: any = {'pointer-events': 'none'}
  spouseLE: number = 0;
  clientLE: number = 0;

  constructor(private matDialog: MatDialog, private globalService: GlobalService, public dialogRef: MatDialogRef<AdjustDesiredClaimAgeComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
      console.log('from modal Adjust', data);
      //this.data = data;
      this.dataFromModalAdjust = data;
      this.scenario = data.scenario;
      
      //file restricted
      //this.minFileRestrictedMonths = parseInt(data.clientFileRestrictedMinMonth);
      //this.minSpouseFileRestrictedClaimMonths = (data.spouseFileRestrictedMinMonth) ? parseInt(data.spouseFileRestrictedMinMonth) : 0;

      //retro filing
      this.isClientRetroFiling = data.isClientRetroFiling;
      this.isSpouseRetroFiling = data.isSpouseRetroFiling;
      /* if(data.isClientRetroFiling || data.isSpouseRetroFiling){
        //need to figure out the 
        if(data.isClientRetroFiling){
          let clientAge = this.calculateAge(data.client.DOB);
          this.minRetroFileClaimAge = ((data.clientAgeMonths < 6) ? clientAge - 1 : clientAge);
          console.log('retro client age', this.minRetroFileClaimAge);
          this.minRetroFileClaimMonths = ((data.clientAgeMonths < 6) ? (12 - (6 - data.clientAgeMonths)) : (data.clientAgeMonths - 6));
        }

        if(data.isSpouseRetroFiling){
          let spouseAge = this.calculateAge(data.clientProfile.Spouses[0].dob);
          this.minSpouseRetroFileClaimAge = ((data.spouseAgeMonths < 6) ? spouseAge - 1 : spouseAge);
          this.minSpouseRetroFileClaimMonths = ((data.spouseAgeMonths < 6) ? (12 - (6 - data.spouseAgeMonths)) : (data.spouseAgeMonths - 6));
        }
      } */



     }

  ngOnInit() {

    //set form with values
    let value = this.dataFromModalAdjust.survivorSwitchAgeMonths ? this.dataFromModalAdjust.survivorSwitchAgeMonths : 0;
    console.log('value', value);
    this.adjustDesiredForm = new FormGroup({      
      clientAgeYears: new FormControl(this.dataFromModalAdjust.clientAgeYears, [Validators.required, Validators.min(62), Validators.max(70)]),
      clientAgeMonths: new FormControl(this.dataFromModalAdjust.clientAgeMonths, [Validators.min(0), Validators.max(11)]),
      spouseAgeYears: new FormControl((this.dataFromModalAdjust.spouseAgeYears) ? this.dataFromModalAdjust.spouseAgeYears : ''),
      spouseAgeMonths: new FormControl((this.dataFromModalAdjust.spouseAgeYears) ? ((this.dataFromModalAdjust.spouseAgeMonths) ? this.dataFromModalAdjust.spouseAgeMonths : 0) : 0),
      survivorSwitchAgeYears: new FormControl((this.dataFromModalAdjust.survivorSwitchAgeYears) ? this.dataFromModalAdjust.survivorSwitchAgeYears : ''),
      survivorSwitchAgeMonths: new FormControl((this.dataFromModalAdjust.survivorSwitchAgeMonths) ? this.dataFromModalAdjust.survivorSwitchAgeMonths : 0),
      spouseSurvivorSwitchAgeYears: new FormControl((this.dataFromModalAdjust.survivorSwitchAgeYears) ? this.dataFromModalAdjust.survivorSwitchAgeYears : ''),
      spouseSurvivorSwitchAgeMonths: new FormControl((this.dataFromModalAdjust.survivorSwitchAgeMonths) ? this.dataFromModalAdjust.survivorSwitchAgeMonths : 0),
      isClientFilingRestricted: new FormControl(this.dataFromModalAdjust.isClientFilingRestricted),
      isSpouseFilingRestricted: new FormControl(this.dataFromModalAdjust.isSpouseFilingRestricted),
      fileRestrictedAgeYears: new FormControl((this.dataFromModalAdjust.fileRestrictedAgeYears) ? this.dataFromModalAdjust.fileRestrictedAgeYears : ''),
      fileRestrictedAgeMonths: new FormControl((this.dataFromModalAdjust.fileRestrictedAgeMonths) ? this.dataFromModalAdjust.fileRestrictedAgeMonths : ''),
      spouseFileRestrictedAgeYears: new FormControl((this.dataFromModalAdjust.spouseFileRestrictedAgeYears) ? this.dataFromModalAdjust.spouseFileRestrictedAgeYears : ''),
      spouseFileRestrictedAgeMonths: new FormControl((this.dataFromModalAdjust.spouseFileRestrictedAgeMonths) ? this.dataFromModalAdjust.spouseFileRestrictedAgeMonths : ''),
      saveDCA: new FormControl((!this.dataFromModalAdjust.displayedDCAToggleOnMessage && !this.dataFromModalAdjust.displayedDCAToggleOffMessage) ? true : this.dataFromModalAdjust.saveDCA),
      //(this.dataFromModalAdjust.saveDCA) ? this.dataFromModalAdjust.saveDCA : true), //default to yes/true/on
      displayedDCAToggleOnMessage: new FormControl((this.dataFromModalAdjust.displayedDCAToggleOnMessage) ? this.dataFromModalAdjust.displayedDCAToggleOnMessage : false),
      displayedDCAToggleOffMessage: new FormControl((this.dataFromModalAdjust.displayedDCAToggleOffMessage) ? this.dataFromModalAdjust.displayedDCAToggleOffMessage : false),
      swappedClaim: new FormControl(this.dataFromModalAdjust.swappedClaim),
      isClientRetroFiling: new FormControl(this.dataFromModalAdjust.isClientRetroFiling),
      isSpouseRetroFiling: new FormControl(this.dataFromModalAdjust.isSpouseRetroFiling),
      
      clientDefaultAgeVal: new FormControl(this.dataFromModalAdjust.clientDefaultAgeVal),
      partnerDefaultAgeVal: new FormControl(this.dataFromModalAdjust.partnerDefaultAgeVal),
      isSurvivorShown: new FormControl(false),
      isSurvivorForClient: new FormControl(true)
    });
    if(this.dataFromModalAdjust.isClientFilingRestricted != null){
      this.isClientFilingRestricted = false;//this.dataFromModalAdjust.isClientFilingRestricted;
    }
    if(this.dataFromModalAdjust.isSpouseFilingRestricted != null){
      this.isSpouseFilingRestricted = false;//this.dataFromModalAdjust.isSpouseFilingRestricted;
    }
    this.isClientAgeReadOnly = this.dataFromModalAdjust.isClientAgeDisable;
    this.isSpouseAgeReadOnly = this.dataFromModalAdjust.isSpouseAgeDisable;
    console.log('this.dataFromModalAdjust', this.dataFromModalAdjust);
    /* if (this.dataFromModalAdjust.clientAgeYears && this.dataFromModalAdjust.survivorSwitchAgeYears) {
      if (Number(this.dataFromModalAdjust.survivorSwitchAgeYears) <= (this.dataFromModalAdjust.clientAgeYears)) {
        this.isSurvivorBenefitFirstClaim = true;
      } else {
        this.isSurvivorBenefitFirstClaim = false;
      }
    } */ 

    //this.isSurvivorBenefitFirstClaim = this.dataFromModalAdjust.swappedClaim;
    
    //this.adjustDesiredForm.get('swappedClaim').patchValue(!this.isSurvivorBenefitFirstClaim);
    /* if (data.clientProfile.Spouses[0].maritalStatus != 'Single' && data.clientProfile.Spouses[0].maritalStatus != 'Widowed' && data.clientProfile.IsLegalSpouse){
      if (this.dataFromModalAdjust.spouseAgeYears && this.dataFromModalAdjust.survivorSwitchAgeYears) {
        if (Number(this.dataFromModalAdjust.survivorSwitchAgeYears) <= (this.dataFromModalAdjust.spouseAgeYears)) {
          this.isSpouseSurvivorBenefitFirstClaim = false;
        } else {
          this.isSpouseSurvivorBenefitFirstClaim = true;
        }
        //this.isSpouseSurvivorBenefitFirstClaim = true;
        console.log('this.isSpouseSurvivorBenefitFirstClaim', this.isSpouseSurvivorBenefitFirstClaim);
      }
      this.isSurvivorBenefitFirstClaim = true;
    } */

    if((this.scenario == 'FRA' || this.scenario == 'First Alternate' || this.scenario == 'First Alternate (Retroactive File)')){
      this.isFRAAlt = true;
      //this.isShowSurvivorSection = false;
      //this.isSurvivorBenefitFirstClaim = false;
    }

    this.getClient();
  }

  getClient() {
    
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
        client => {
          this.data = client;
          this.data.clientProfile.Spouses = JSON.parse(this.data.clientProfile.Spouses);
          
          // this.data.clientProfile.Spouses = this.data.clientProfile.Spouses[0].maritalStatus != 'Single' ? Utils.calculateMostProfitableSpouse(this.data, this.data.clientProfile.Spouses): this.data.clientProfile.Spouses;

          //ZSS added for an override if spousal surv
          //idk if this is the best way to do a spousal surv - this is just how the UI handles it
          if (this.data.clientProfile.Spouses[0].maritalStatus != 'Single' && this.data.clientProfile.Spouses[0].maritalStatus != 'Widowed' && this.data.clientProfile.IsLegalSpouse){
            if (this.dataFromModalAdjust.spouseAgeYears && this.dataFromModalAdjust.survivorSwitchAgeYears) {
              if (Number(this.dataFromModalAdjust.survivorSwitchAgeYears) <= (this.dataFromModalAdjust.spouseAgeYears)) {
                //this.isSpouseSurvivorBenefitFirstClaim = false;
              } else {
                //this.isSpouseSurvivorBenefitFirstClaim = true;
              }
              //this.isSpouseSurvivorBenefitFirstClaim = true;
              console.log('this.isSpouseSurvivorBenefitFirstClaim', this.isSpouseSurvivorBenefitFirstClaim);
            }

            if (this.dataFromModalAdjust.spouseAgeYears){
              //this.isSpouseSurvivorBenefitFirstClaim = true;
              
            } else {
              //retirement on top
              console.log('spousal retirement on top if here');
              //this.isSpouseSurvivorBenefitFirstClaim = false;
            }

            //this.isSurvivorBenefitFirstClaim = false;
          }


          let clientAge = this.calculateAge(this.data.client.DOB);
          
          //set Retro validation
          if(this.isClientRetroFiling || this.isSpouseRetroFiling){
            //need to figure out the 
            if(this.isClientRetroFiling && this.dataFromModalAdjust.clientRetroDisplayAge){
             
              let FRA = this.getFRAv2(this.data.client.DOB);
              var currAge = parseInt(this.dataFromModalAdjust.clientRetroDisplayAge.replaceAll(' ', '').split('y')[0]);
              var currMonth = parseInt(this.dataFromModalAdjust.clientRetroDisplayAge.replaceAll(' ', '').split('y')[1].split('m')[0]);
              console.log('currMonth', currMonth);
              var howManyMonthsAllowed = ((currAge * 12) + currMonth) - ((FRA.age * 12) + FRA.month);
              console.log('retro months allowed into the past', howManyMonthsAllowed);
              var maxAllowedInPast = howManyMonthsAllowed > 6 ? 6 : howManyMonthsAllowed;
              console.log('retro max months allowed into the past', maxAllowedInPast);

              this.minRetroFileClaimAge = ((FRA.age < currAge)) ? currAge : FRA.age;
              console.log('retro client age', this.minRetroFileClaimAge);
              this.minRetroFileClaimMonths = currMonth > maxAllowedInPast ? 
                currMonth - maxAllowedInPast : maxAllowedInPast - currMonth;
              console.log('retro client month', this.minRetroFileClaimMonths);
              if(currMonth < maxAllowedInPast && this.minRetroFileClaimMonths > 0){
                this.minRetroFileClaimAge -= 1;
                //this.minRetroFileClaimMonths = 12 - this.minRetroFileClaimMonths;

                console.log('count down to 0');
                //count months down to 0 and subtract the rest/remainder from 12
                var remainder = maxAllowedInPast - currMonth;
                this.minRetroFileClaimMonths = (12 - remainder);
              }

              let isCurrentAgePastFRA = (FRA.age < currAge
                || FRA.age == currAge && FRA.month <= currMonth);

              //this.minRetroFileClaimMonths = (isCurrentAgePastFRA) ? FRA.month : ((FRA.month < 6) ? (13 - (6 - this.minRetroFileClaimMonths)) : (FRA.month - 6));
              //console.log('retro client months', this.minRetroFileClaimMonths);

              let clientAge = this.calculateAge(this.data.client.DOB);
              //let FRA = this.getFRAv2(this.data.client.DOB);
           
              
              //this.minRetroFileClaimAge = (isCurrentAgePastFRA) ? FRA.age : ((FRA.month < 6) ? clientAge - 1 : clientAge);
              console.log('retro client age', this.minRetroFileClaimAge);
              //this.minRetroFileClaimMonths = (isCurrentAgePastFRA) ? FRA.month : ((FRA.month < 6) ? (13 - (6 - this.minRetroFileClaimMonths)) : (FRA.month - 6));
              console.log('retro client months', this.minRetroFileClaimMonths);
              console.log('this.adjustDesiredForm.value.clientAgeMonths', FRA.month);
            } else if(this.isClientRetroFiling){
              console.log('fell in here on load first time');
              let clientAge = this.calculateAge(this.data.client.DOB);
              let FRA = this.getFRAv2(this.data.client.DOB);

              let isCurrentAgePastFRA = (FRA.age == this.adjustDesiredForm.value.clientAgeYears && FRA.month == this.adjustDesiredForm.value.clientAgeMonths);
              
              this.minRetroFileClaimAge = (isCurrentAgePastFRA) ? FRA.age : ((FRA.month < 6) ? clientAge - 1 : clientAge);
              console.log('retro client age', this.minRetroFileClaimAge);
              this.minRetroFileClaimMonths = (isCurrentAgePastFRA) ? FRA.month : ((FRA.month < 6) ? (13 - (6 - this.minRetroFileClaimMonths)) : (FRA.month - 6));
              console.log('retro client months', this.minRetroFileClaimMonths);
              console.log('this.adjustDesiredForm.value.clientAgeMonths', FRA.month);
            }
    
            if(this.isSpouseRetroFiling && this.dataFromModalAdjust.partnerRetroDisplayAge){
              
              let FRA = this.getFRAv2(this.data.clientProfile.Spouses[0].dob);
              var currAge = parseInt(this.dataFromModalAdjust.partnerRetroDisplayAge.replaceAll(' ', '').split('y')[0]);
              var currMonth = parseInt(this.dataFromModalAdjust.partnerRetroDisplayAge.replaceAll(' ', '').split('y')[1].split('m')[0]);
              console.log('spouse currMonth', currMonth);
              var howManyMonthsAllowed = ((currAge * 12) + currMonth) - ((FRA.age * 12) + FRA.month);
              console.log('spouse howManyMonthsAllowed', howManyMonthsAllowed);
              var maxAllowedInPast = howManyMonthsAllowed > 6 ? 6 : howManyMonthsAllowed;
              console.log('spouse maxAllowedInPast', maxAllowedInPast);
              
              this.minSpouseRetroFileClaimAge = ((FRA.age < currAge)) ? currAge : FRA.age;
              console.log('retro spouse age', this.minSpouseRetroFileClaimAge);
              this.minSpouseRetroFileClaimMonths = currMonth > maxAllowedInPast ? 
                currMonth - maxAllowedInPast : maxAllowedInPast - currMonth;
              console.log('retro spouse month', this.minSpouseRetroFileClaimMonths);
              if(currMonth < maxAllowedInPast && this.minSpouseRetroFileClaimMonths > 0){
                this.minSpouseRetroFileClaimAge -= 1;
                //this.minSpouseRetroFileClaimMonths = 12 - this.minSpouseRetroFileClaimMonths;

                var remainder = maxAllowedInPast - currMonth;
                this.minSpouseRetroFileClaimMonths = (12 - remainder);
              }
              console.log('retro spouse month', this.minSpouseRetroFileClaimMonths);

              let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
              let isCurrentAgePastFRA = (FRA.age < currAge
                || FRA.age == currAge && FRA.month <= currMonth);

              //this.minSpouseRetroFileClaimAge = (isCurrentAgePastFRA) ? this.adjustDesiredForm.value.spouseAgeYears : ((FRA.month < 6) ? spouseAge - 1 : spouseAge);
              //this.minSpouseRetroFileClaimAge = (isCurrentAgePastFRA) ? (((currAge - FRA.age) == 0) ? currAge : currAge - 1) : ((FRA.month < 6) ? spouseAge - 1 : spouseAge);
              //this.minSpouseRetroFileClaimAge = ((FRA.month < 6) ? spouseAge - 1 : spouseAge);
              this.minSpouseRetroFileClaimAge = ((currMonth < 6) ? spouseAge - 1 : spouseAge);
              console.log('retro spouse age', this.minSpouseRetroFileClaimAge);
              //this.minSpouseRetroFileClaimMonths = (isCurrentAgePastFRA) ? FRA.month : ((FRA.month < 6) ? (13 - (6 - this.minSpouseRetroFileClaimMonths)) : (FRA.month - 6));
              console.log('this.adjustDesiredForm.value.spouseAgeMonths', FRA.month);
              console.log('this.minSpouseRetroFileClaimMonths', this.minSpouseRetroFileClaimMonths);
            } else if(this.isSpouseRetroFiling){
              let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
              let FRA = this.getFRAv2(this.data.clientProfile.Spouses[0].dob);

              //let isCurrentAgePastFRA = (((this.adjustDesiredForm.value.spouseAgeYears * 12) + this.adjustDesiredForm.value.spouseAgeMonths) > ((FRA.age * 12) + FRA.month));
              let isCurrentAgePastFRA = (FRA.age == this.adjustDesiredForm.value.spouseAgeYears && FRA.month == this.adjustDesiredForm.value.spouseAgeMonths);

              //this.minSpouseRetroFileClaimAge = (isCurrentAgePastFRA) ? this.adjustDesiredForm.value.spouseAgeYears : ((FRA.month < 6) ? spouseAge - 1 : spouseAge);
              this.minSpouseRetroFileClaimAge = (isCurrentAgePastFRA) ? FRA.age : ((FRA.month < 6) ? spouseAge - 1 : spouseAge);
              console.log('retro spouse age', this.minSpouseRetroFileClaimAge);
              this.minSpouseRetroFileClaimMonths = (isCurrentAgePastFRA) ? FRA.month : ((FRA.month < 6) ? (13 - (6 - this.minSpouseRetroFileClaimMonths)) : (FRA.month - 6));
              console.log('this.adjustDesiredForm.value.spouseAgeMonths', FRA.month);
            }
          }
          this.minClaimAge = (this.minRetroFileClaimAge) ? this.minRetroFileClaimAge : clientAge > 62 ? clientAge : 62;
          // let spouseAge = client.clientProfile.Spouses[0].dob ? this.calculateAge(this.data.clientProfile.Spouses[0].dob): 0;
          // let clientDOBMonth = new Date (this.data.client.DOB).getMonth();
          // let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth();
          // let spouseMonthIndex = clientDOBMonth < spouseDOBMonth ? 1 : 0;
          // let clientMonthIndex = spouseDOBMonth < clientDOBMonth ? 1 : 0;
          // let clientRemainingYear = this.data.clientProfile.LifeExpectancy - clientAge;
          // let spouseRemainingYear = (this.data.clientProfile.Spouses[0].LifeExpectancy || 0) - spouseAge;
          // this.minClaimAge = clientRemainingYear > spouseRemainingYear && spouseAge > 0 && this.isShowSurvivorSection ? clientAge + spouseRemainingYear - clientMonthIndex : this.minClaimAge;
          console.log('minClaimAge 01', this.minClaimAge);

          this.maxSpouseClaimMonths = (Number(this.dataFromModalAdjust.spouseAgeYears) == 70) ? 0 : 11;
          
          this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();

          //set min on claim month for client to be todays age
          if(clientAge >= 62){
            let clientDOBMonth = new Date (this.data.client.DOB).getMonth() + 1;
            this.minClientClaimMonths = (this.minRetroFileClaimMonths && this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge) ? this.minRetroFileClaimMonths : (this.minClaimAge < 70 && this.minClaimAge == this.adjustDesiredForm.value.clientAgeYears) ? clientDOBMonth == 1 ? 0 : (new Date().getMonth() + 1 >= clientDOBMonth) ? ((new Date().getMonth() + 1) - clientDOBMonth) : (13 - clientDOBMonth) : this.minClientClaimMonths;
            this.adjustDesiredForm.get('clientAgeMonths').setValidators((this.minRetroFileClaimMonths) ? [Validators.required, Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)] : [Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
            this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();
            //if(this.minRetroFileClaimMonths){
              this.adjustDesiredForm.get('clientAgeMonths').markAsTouched();
            //}
            console.log('minClientClaimMonths 456', this.minClientClaimMonths);
          }

          if(this.isClientFilingRestricted){
            this.adjustDesiredForm.get("fileRestrictedAgeYears").setValidators([Validators.min(69), Validators.max(69)]);
            this.adjustDesiredForm.get("fileRestrictedAgeMonths").setValidators([Validators.min(this.minFileRestrictedMonths), Validators.max(11)]);

            this.adjustDesiredForm.get("fileRestrictedAgeYears").updateValueAndValidity();
            this.adjustDesiredForm.get("fileRestrictedAgeMonths").updateValueAndValidity();
          }          
          let isResetspouseSurvivorSwitchAgeMonths = false;
          if(client.clientProfile.Spouses && client.clientProfile.Spouses.length > 0) {
            let spouseAge = client.clientProfile.Spouses[0] ? this.calculateAge(this.data.clientProfile.Spouses[0].dob): 0;
            var isSpouseAllowedToCollectAt60 = (spouseAge < 60 && ((60 - spouseAge) + clientAge > client.clientProfile.LifeExpectancy));
            var spouseCurrAge = (this.dataFromModalAdjust.partnerDefaultAgeVal) ? parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[0]) : spouseAge;
            this.spouseMinClaimAge = (this.minSpouseRetroFileClaimAge) ? this. minSpouseRetroFileClaimAge : spouseAge >= 62 ? spouseAge : (isSpouseAllowedToCollectAt60) ? 60 : spouseCurrAge;
            // this.spouseMinClaimAge = spouseRemainingYear > clientRemainingYear && spouseAge > 0 ? spouseAge + clientRemainingYear - spouseMonthIndex : this.spouseMinClaimAge;
            console.log('this.minSpouseRetroFileClaimAge', this.minSpouseRetroFileClaimAge);

            if(this.isSpouseFilingRestricted){
              this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").setValidators([Validators.min(69), Validators.max(69)]);
              this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").setValidators([Validators.min(this.minSpouseFileRestrictedClaimMonths), Validators.max(11)]);
              this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").updateValueAndValidity();
              this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").updateValueAndValidity();
            }
            
            if(client.clientProfile.Spouses[0].maritalStatus != 'Widowed') {
              if (client.clientProfile.Spouses[0].maritalStatus == 'Single' || client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
                for (let spouse of client.clientProfile.Spouses) {
                  if (spouse.maritalStatus == 'Divorced' && !spouse.alive && spouse.tenyears){ // && !this.isFRAAlt) {
                    this.isDivorceCaseMeet = true;
                    console.log('here 01');
                    this.isShowSurvivorSection = true;
                    this.isSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;       
                    console.log('we divorced');             
                  } else {
                  
                    //SPOUSE_DIES_BEFORE_CLIENT_REACHES_YEAR_OF_AGE_70
                    var yearsUntilClientHits70 = 70 - clientAge;
                    //console.log('yearsUntilClientHits70', yearsUntilClientHits70);
                    //console.log('spouse', spouse);
                    var yearsUntilSpouseDies = spouse.exSpouseLifeExpectancy - this.calculateAge(spouse.dobStr);
                    //console.log('yearsUntilSpouseDies', yearsUntilSpouseDies);
                    if (spouse.maritalStatus == 'Divorced' && (!spouse.alive || (yearsUntilSpouseDies < yearsUntilClientHits70)) && spouse.tenyears) {
                      console.log('check on 396');
                      //here 061924 => working on a fix for HPV-2700
                      this.isShowSurvivorSection = true;
                      this.isSurvivorForClient = true;
                      this.isDivorceCaseMeet = true;
                      //this.isSurvivorBenefitFirstClaim = true;//!this.dataFromModalAdjust.value.swappedClaim;
                      //console.log('check on this.isSurvivorBenefitFirstClaim', this.isSurvivorBenefitFirstClaim);
                      //this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(0);
                      //this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(0);
                    }
                  }
                }
              } else if (client.clientProfile.Spouses && client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                //Switch should appear in Alt if the person is going to be widowed by age 69y11m or younger 
                console.log('IN HERE FOR CLIENT SWITCH',  (this.data.clientProfile.Spouses[0].LifeExpectancy - spouseAge) + clientAge);
                if((this.data.clientProfile.Spouses[0].LifeExpectancy - spouseAge) + clientAge <= 69){
                  console.log('IN HERE FOR CLIENT SWITCH; Spouse age at Client death', (this.data.clientProfile.Spouses[0].LifeExpectancy - spouseAge) + clientAge);
                  this.isShowSurvivorSection = true;
                  //HACK: should have a better way for this on married couples then to use a divorce bool
                  this.isDivorceCaseMeet = true;
                  this.isSurvivorForClient = true;
                  this.isSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;

                  this.adjustDesiredForm.controls['spouseSurvivorSwitchAgeYears'].patchValue(0);
                  this.adjustDesiredForm.controls['spouseSurvivorSwitchAgeMonths'].patchValue(0);
                  isResetspouseSurvivorSwitchAgeMonths = true;

                  //TODO: need to figure out if values are saved to profile a certain way....dont know if this happens later in logic
                  //this.isSurvivorBenefitFirstClaim = true;
                  if (this.dataFromModalAdjust.clientAgeYears && this.dataFromModalAdjust.survivorSwitchAgeYears) {
                    if (Number(this.dataFromModalAdjust.survivorSwitchAgeYears) <= (this.dataFromModalAdjust.clientAgeYears)) {
                      //this.isSurvivorBenefitFirstClaim = false;
                      console.log('should swith survivor');
                    } else {
                      /* this.isSurvivorBenefitFirstClaim = true;
                      this.adjustDesiredForm.controls['swappedClaim'].patchValue(false); */
                    }
                  } else {
                    //this.isSurvivorBenefitFirstClaim = true;
                  } 

                  //this.isSpouseSurvivorBenefitFirstClaim = false;
                }

                //lets make sure that spouse age is required at-least on page load
                this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
                this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();
                let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
                let getPresentMonth = new Date().getMonth() + 1;
                this.minSpouseClaimMonths = (this.minRetroFileClaimMonths && this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge) ? this.minRetroFileClaimMonths : (spouseCurrAge == this.adjustDesiredForm.value.spouseAgeYears ? (spouseDOBMonth == getPresentMonth ? 0 : (13 - spouseDOBMonth)): (spouseCurrAge < this.adjustDesiredForm.value.spouseAgeYears? 0 : this.minSpouseClaimMonths));
                this.adjustDesiredForm.get('spouseAgeMonths').setValidators((this.minRetroFileClaimMonths) 
                  ? [Validators.required, Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)] 
                  : [Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
                this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
                if(this.minRetroFileClaimMonths){
                  this.adjustDesiredForm.get('spouseAgeMonths').markAsTouched();
                }

                this.adjustDesiredForm.get("clientAgeYears").markAsTouched();
                this.adjustDesiredForm.get("spouseAgeYears").markAsTouched();
              }

              if (this.isDivorceCaseMeet) {
                this.minClaimAge = (this.minRetroFileClaimAge) ? this. minRetroFileClaimAge : clientAge > 60 ? clientAge : 60;
                console.log('divorce minClaimAge 02', this.minClaimAge);
                if (!this.isSurvivorBenefitFirstClaim) {
                  if (this.dataFromModalAdjust.survivorSwitchAgeYears == '' && this.dataFromModalAdjust.clientAgeYears)  {
                    this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                    this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.clientAgeMonths);
                    
                    //var clientCurrAge = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
                    var clientCurrMonth = (this.dataFromModalAdjust.clientDefaultAgeVal) ? parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]) : 0;
                    //var clientCurrMonth = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
                    console.log('earliest age month', currMonth);
                    // Retirement benefit first and Survivir Benefits are second
                    let clientAge = this.calculateAge(this.data.client.DOB);
                    this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
                    this.maxSurvivorSwitchClaimAge = 70;
                    this.maxSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) != 0  ? 11 : 0;
                    this.minSurvivorSwitchClaimMonths = clientAge >= 62 ? clientCurrMonth : 0;


                    this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
                    this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
                    this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators((this.minSurvivorSwitchClaimMonths) 
                    ? [Validators.required, Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)] 
                    : [Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
                    this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();

                    //this.adjustDesiredForm.get('survivorSwitchAgeMonths').markAsTouched();

                    this.adjustDesiredForm.controls['clientAgeYears'].patchValue('');
                    this.adjustDesiredForm.controls['clientAgeMonths'].patchValue('');
                    // this.isSurvivorBenefitFirstClaim = false;
                  }

                  // this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
                  // this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
                  // this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([]);
                  // this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
                  console.log('clearing validation here? why?');
                  this.adjustDesiredForm.get('clientAgeYears').setValidators([]);
                  this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
                } else {
                  this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
                  this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
                }

              }

              //HACK: added to allow for spouse to use survivor switch
              //this is a hack because it uses the clients inputs for switch, and swaps them later in the API
              //need to allow Survivor when someone is a Widowmaker (ex: )
              if(client.clientProfile.Spouses && client.clientProfile.Spouses[0].maritalStatus == 'Married' && !this.isShowSurvivorSection) {
                console.log('THIS IS WHERE I WANNA B');
                //Be widowed any time between the age of 60y0m and 69y11m
                if((client.clientProfile.LifeExpectancy - clientAge) + this.calculateAge(this.data.clientProfile.Spouses[0].dob) <= 60
                  || (client.clientProfile.LifeExpectancy - clientAge) + this.calculateAge(this.data.clientProfile.Spouses[0].dob) <= 69){
                  console.log('THIS IS WHERE I WANNA B too');
                  this.isSurvivorForClient = false;
                  this.isShowSurvivorSection = true;
                  this.isSpouseSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;
                  console.log('THIS IS WHERE I WANNA B too', this.isSpouseSurvivorBenefitFirstClaim);
                  this.isSurvivorBenefitFirstClaim = false;

                  if (this.dataFromModalAdjust.spouseAgeYears && this.dataFromModalAdjust.survivorSwitchAgeYears) {
                    if (Number(this.dataFromModalAdjust.survivorSwitchAgeYears) <= (this.dataFromModalAdjust.spouseAgeYears)) {
                      //this.isSpouseSurvivorBenefitFirstClaim = false;
                    } else {
                      //this.isSpouseSurvivorBenefitFirstClaim = true;
                    }
                  } 
                  else {
                    if(this.dataFromModalAdjust.spouseAgeYears){
                      //this.isSpouseSurvivorBenefitFirstClaim = true;
                    } else {
                      //this.isSpouseSurvivorBenefitFirstClaim = false;
                    }
                  }
                } else {
                  //console.log('in here, set spouse surv');
                  this.isSurvivorForClient = false;
                  this.isSpouseSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;
                  console.log('THIS IS WHERE I WANNA B too', this.isSpouseSurvivorBenefitFirstClaim);
                  this.isSurvivorBenefitFirstClaim = false;
                  this.adjustDesiredForm.controls['isSurvivorForClient'].patchValue(false);
                  
                }
              }

              //console.log('commented out spouse?');
              //ZSS 05/16/23: removed/commented out - issues with Widows and form validation
              /* if (client.clientProfile.Spouses[0].maritalStatus != 'Single') {
                console.log('not single');
                this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
                this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();
  
                this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.min(0), Validators.max(this.maxSpouseClaimMonths)]);
                this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
              } */

              if (this.isClientAgeReadOnly) {
                this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
                this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();
              }
            } else {
              //console.log('clear spouse?');
              //clear spouse
              this.minClaimAge = (this.minRetroFileClaimAge) ? this. minRetroFileClaimAge : clientAge > 60 ? clientAge : 60;
              console.log('minClaimAge 03', this.minClaimAge);
              this.adjustDesiredForm.controls['spouseAgeYears'].patchValue('');
              this.adjustDesiredForm.controls['spouseAgeMonths'].patchValue('');
              
              //this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);                              
              this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);                              
              this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
              console.log('here 02');
              this.isShowSurvivorSection = true;
              this.isSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;
            }
          }
          if (this.isClientAgeReadOnly) {
            this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required]);
            this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();

           /*  this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.required]);
            this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();

            this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.adjustDesiredForm.value.clientAgeYears);
            this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.adjustDesiredForm.value.clientAgeMonths); */
          }
          if (this.isSpouseAgeReadOnly) {
            this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required]);
            this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();

            this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.required]);
            this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
          }

          this.mostProfitableSpouse = Utils.calculateMostProfitableSpouse(this.data, this.data.clientProfile.Spouses);
          console.log('here we go 005z', this.mostProfitableSpouse);
          // SMALLA: if spouse die before client no need to show survivor switch section - HPV-2464
          let isMostProfitableSpouse = this.data.clientProfile.Spouses[0].maritalStatus == 'Married' && this.mostProfitableSpouse[0].maritalStatus == 'Widowed' && !this.isSurvivorForClient && this.data.clientProfile.Spouses[0].LifeExpectancy - spouseCurrAge  < this.data.clientProfile.LifeExpectancy - clientAge ? false: true;
          console.log('isMostProfitableSpouse1', isMostProfitableSpouse);
          isMostProfitableSpouse = isMostProfitableSpouse ? this.data.clientProfile.Spouses[0].maritalStatus == 'Married' && this.mostProfitableSpouse[0].maritalStatus == 'Widowed' && this.isSurvivorForClient && this.data.clientProfile.Spouses[0].LifeExpectancy - spouseCurrAge  > this.data.clientProfile.LifeExpectancy - clientAge 
            //ZSS 061124: added to help with displaying Switch for couples remarried after 60 and when spouse lives longer and passed 70 
            ? this.data.clientProfile.Spouses[0].maritalStatus == 'Married' && this.mostProfitableSpouse[0].maritalStatus == 'Widowed' && !this.isSurvivorForClient && this.data.clientProfile.Spouses[0].LifeExpectancy - spouseCurrAge  > this.data.clientProfile.LifeExpectancy - clientAge 
              ? false : true : isMostProfitableSpouse
            //? this.data.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.isSurvivorForClient && this.mostProfitableSpouse[0].exSpouseLifeExpectancy - this.getCurrentAgeByDOB(this.mostProfitableSpouse[0].dobStr)  > this.data.clientProfile.LifeExpectancy - clientAge 
            //  ? false : true : isMostProfitableSpouse
            ? false : true : isMostProfitableSpouse;
          console.log('isMostProfitableSpouse2', isMostProfitableSpouse);
          console.log('this.isSurvivorForClient', this.isSurvivorForClient);
          console.log('spouse LE-CA', this.mostProfitableSpouse[0].exSpouseLifeExpectancy - this.getCurrentAgeByDOB(this.mostProfitableSpouse[0].dobStr));
          console.log('client LE-CA', this.data.clientProfile.LifeExpectancy - clientAge);

          if (this.data.clientProfile.Spouses[0].maritalStatus == 'Single' && !this.data.clientProfile.Spouses[1].alive && this.data.clientProfile.Spouses[1].tenyears 
          || this.data.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
          || this.mostProfitableSpouse && this.mostProfitableSpouse[0].maritalStatus == 'Widowed' && isMostProfitableSpouse) {
            this.isSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;
            //this.isShowSurvivorSection = true;
            if (this.dataFromModalAdjust.clientAgeYears) {
              if (this.isSurvivorBenefitFirstClaim) {// && this.dataFromModalAdjust.survivorSwitchAgeYears < this.dataFromModalAdjust.clientAgeYears) {
                
                this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                this.adjustDesiredForm.controls['clientAgeMonths'].patchValue((this.dataFromModalAdjust.clientAgeMonths) ? this.dataFromModalAdjust.clientAgeMonths : 0);
                this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
                this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);

                /* this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
                this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);
                this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.clientAgeMonths); */

                // this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
                // this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
                console.log('here 001');
                //this.isSurvivorBenefitFirstClaim = false
              } else {
                //if(this.dataFromModalAdjust.survivorSwitchAgeYears < this.dataFromModalAdjust.clientAgeYears){
                //this.isSurvivorBenefitFirstClaim = !this.dataFromModalAdjust.swappedClaim;
                if(this.isSurvivorBenefitFirstClaim){
                  /* this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                  this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.dataFromModalAdjust.clientAgeMonths);
                  this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
                  this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths); */

                  this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
                  this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);
                  this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                  this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.clientAgeMonths);

                  //this.isSurvivorBenefitFirstClaim = true;
                } else {
                  /* this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
                  this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);
                  this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                  this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.clientAgeMonths); */

                  this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.dataFromModalAdjust.clientAgeYears);
                  this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.dataFromModalAdjust.clientAgeMonths);
                  this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
                  this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);

                  // this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
                  // this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
                  //this.isSurvivorBenefitFirstClaim = false;
                }
                console.log('here 002');
                console.log('this.isSurvivorBenefitFirstClaim', this.isSurvivorBenefitFirstClaim);
                //this.isSurvivorBenefitFirstClaim = true
              }
            } else {
              //this.isSurvivorBenefitFirstClaim = true;
              this.adjustDesiredForm.controls['clientAgeYears'].patchValue('');
              this.adjustDesiredForm.controls['clientAgeMonths'].patchValue('');
              this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
              this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);
              //this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
              //this.isSurvivorBenefitFirstClaim = false
              //var clientCurrAge = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
              var clientCurrMonth = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
              console.log('earliest age month', currMonth);
              // Retirement benefit first and Survivir Benefits are second
              let clientAge = this.calculateAge(this.data.client.DOB);
              this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
              this.minSurvivorSwitchClaimAge = (this.minRetroFileClaimAge) ? this.minRetroFileClaimAge : this.minSurvivorSwitchClaimAge;
              this.maxSurvivorSwitchClaimAge = 70;
              this.maxSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) != 0  ? 11 : 0;
              this.minSurvivorSwitchClaimMonths = clientAge >= 62 && (!this.isClientAgeReadOnly && this.adjustDesiredForm.value.survivorSwitchAgeYears != this.maxSurvivorSwitchClaimAge) ? clientCurrMonth : 0;


              this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
              this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
              this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators((this.minSurvivorSwitchClaimMonths && this.adjustDesiredForm.value.survivorSwitchAgeYears == this.minRetroFileClaimAge) 
              ? [Validators.required, Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)] 
              : [Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
              this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
              this.adjustDesiredForm.get('survivorSwitchAgeMonths').markAsTouched();

              console.log('here 003', this.minRetroFileClaimAge);
            }
            console.log('here 03');
            this.isShowSurvivorSection = true;
            // this.isShowSurvivorSection = this.data.clientProfile.Spouses[0].maritalStatus != 'Married' ? true: ((((client.clientProfile.LifeExpectancy - clientAge) + this.calculateAge(this.data.clientProfile.Spouses[0].dob) <= 60)
            // || (client.clientProfile.LifeExpectancy - clientAge) + this.calculateAge(this.data.clientProfile.Spouses[0].dob) <= 69)? true: this.isShowSurvivorSection);
          } else {
            if (this.data.clientProfile.Spouses[0].maritalStatus == 'Married'){
                console.log('zss here 88');
                //this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);                              
                //this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
                console.log('here', this.dataFromModalAdjust.clientDefaultAgeVal);
                var clientCurrAge = (!this.dataFromModalAdjust.clientDefaultAgeVal) ? 0 : parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
                var clientCurrMonth = (!this.dataFromModalAdjust.clientDefaultAgeVal) ? 0 : parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
                var clientMinMonth = clientAge >= 62 ? clientCurrMonth : 0;
                this.minClientClaimMonths = (this.minRetroFileClaimMonths && this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge) ? this.minRetroFileClaimMonths : (this.adjustDesiredForm.value.clientAgeYears == clientCurrAge) ? ((this.minRetroFileClaimMonths && this.adjustDesiredForm.value.clientAgeYears > this.minRetroFileClaimAge) ? 0 : clientMinMonth) : 0;
                this.adjustDesiredForm.get('clientAgeMonths').setValidators((this.minClientClaimMonths && this.adjustDesiredForm.value.clientAgeYears) 
                  ? [Validators.required, Validators.min(this.minClientClaimMonths), Validators.max(12)]
                  : [Validators.min(this.minClientClaimMonths), Validators.max(12)]);
                this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();
                this.adjustDesiredForm.get('clientAgeMonths').markAsTouched();
                //this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
                //this.adjustDesiredForm.get('clientAgeYears').markAsTouched();
                console.log('check 001', clientMinMonth);
                console.log('check 002', this.minClientClaimMonths);

                let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
                var partnerCurrMonth = (this.dataFromModalAdjust.partnerDefaultAgeVal) ? parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]) : this.minSpouseClaimMonths;
                var partnerMinMonth = spouseAge >= 62 && spouseAge == this.adjustDesiredForm.value.spouseAgeYears ? partnerCurrMonth : 0;

                if(this.isShowSurvivorSection && !this.isSurvivorForClient){
                    this.adjustDesiredForm.get('survivorSwitchAgeYears').reset();
                    this.adjustDesiredForm.get('survivorSwitchAgeYears').clearValidators();
                    this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();

                  if(!this.isSpouseSurvivorBenefitFirstClaim){
                    console.log('here ? 1');
                    this.minSpouseClaimMonths = (this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : partnerMinMonth;
                    this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').setValidators((this.minSpouseClaimMonths) 
                      ? [Validators.required, Validators.min(partnerMinMonth), Validators.max(12)] 
                      : [Validators.min(partnerMinMonth), Validators.max(12)]);
                    this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').updateValueAndValidity();
                    this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').markAsTouched();
                    if ((this.adjustDesiredForm.value.spouseAgeYears || 0) > 0) {
                      //this.adjustDesiredForm.get('spouseAgeMonths').reset();
                      this.adjustDesiredForm.get('spouseAgeMonths').clearValidators();
                      this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.min(partnerMinMonth), Validators.max(12)]);
                      this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
                    }
                  } else {
                    console.log('here ? 2');
                    // let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
                    // var partnerCurrMonth = (this.dataFromModalAdjust.partnerDefaultAgeVal) ? parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]) : this.minSpouseClaimMonths;
                    // var partnerMinMonth = spouseAge >= 62 ? partnerCurrMonth : 0;
                    this.minSpouseClaimMonths = (this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : partnerMinMonth;
                    this.adjustDesiredForm.get('spouseAgeMonths').setValidators((this.minSpouseClaimMonths) 
                      ? [Validators.required, Validators.min(partnerMinMonth), Validators.max(12)] 
                      : [Validators.min(partnerMinMonth), Validators.max(12)]);
                    this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
                    this.adjustDesiredForm.get('spouseAgeMonths').markAsTouched();

                    this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').reset();
                    if (this.dataFromModalAdjust.survivorSwitchAgeMonths && !isResetspouseSurvivorSwitchAgeMonths) {
                      this.adjustDesiredForm.controls['spouseSurvivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);
                    }
                  }

                } else {
                  console.log('get hurr?', this.mostProfitableSpouse);
                  var isRemarriedAfter60 = !this.isSurvivorForClient && this.data.clientProfile.Spouses[0].LifeExpectancy - spouseCurrAge  > this.data.clientProfile.LifeExpectancy - clientAge;
                  if(this.mostProfitableSpouse[0].maritalStatus == "Widowed" && isRemarriedAfter60){
                    this.isShowSurvivorSection = true;
                    this.isSurvivorForClient = true;
                  }

                  /* var partnerCurrAge =  parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
                  this.minSpouseRetroFileClaimAge = (this.minSpouseRetroFileClaimAge) ? this.minSpouseRetroFileClaimAge : partnerCurrAge;
                  this.adjustDesiredForm.get('spouseAgeYears').setValidators((this.minSpouseRetroFileClaimAge) 
                    ? [Validators.required, Validators.min(this.minSpouseRetroFileClaimAge), Validators.max(70)] 
                    : [Validators.min(this.minSpouseRetroFileClaimAge), Validators.max(70)]);
                  this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();
                  this.adjustDesiredForm.get('spouseAgeYears').markAsTouched(); */

                  this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
                  this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
                  this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators((this.minSurvivorSwitchClaimMonths) 
                  ? [Validators.required, Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)] 
                  : [Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
                  this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
                  this.adjustDesiredForm.get('survivorSwitchAgeMonths').markAsTouched();
                }
            } else {
              //not married here
              this.isSurvivorBenefitFirstClaim = !this.adjustDesiredForm.value.swappedClaim;//true;
            }
          }
/* 
          if(!this.isSurvivorForClient && this.isSpouseSurvivorBenefitFirstClaim && this.isShowSurvivorSection){

            this.adjustDesiredForm.controls['spouseAgeYears'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeYears);
            this.adjustDesiredForm.controls['spouseAgeMonths'].patchValue(this.dataFromModalAdjust.survivorSwitchAgeMonths);
            this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.dataFromModalAdjust.spouseAgeYears);
            this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.dataFromModalAdjust.spouseAgeMonths);

            console.log('check object for spouse', this.adjustDesiredForm.value);
          }
 */
          console.log('this.isShowSurvivorSection', this.isShowSurvivorSection)
          console.log('isSurvivorForClient', this.isSurvivorForClient);
          console.log('this.maxClaimAge', this.maxClaimAge)
          console.log('this.this.maxSurvivorSwitchClaimAge', this.maxSpouseSurvivorSwitchClaimAge);
          console.log('this.adjustDesiredForm.', this.adjustDesiredForm)
          if (this.isShowSurvivorSection) {
            this.resetValidation();
          }         
          // this.adjustDesiredForm.controls['clientAgeYears'].markAsTouched();
          // this.adjustDesiredForm.controls['survivorSwitchAgeYears'].markAsTouched();
          // this.adjustDesiredForm.controls['spouseAgeYears'].markAsTouched();
          // this.adjustDesiredForm.controls['survivorSwitchAgeYears'].markAsTouched();
          // this.adjustDesiredForm.controls['survivorSwitchAgeYears'].setErrors({'incorrect': false});

          // if (this.isShowSurvivorSection) {
          //   if (this.isSurvivorForClient) {
          //     console.log('here i am 01');
          //     if (this.isSpouseSurvivorBenefitFirstClaim) {
          //       if (this.adjustDesiredForm.value.survivorSwitchAgeYears < this.adjustDesiredForm.value.clientAgeYears) {
          //         this.adjustDesiredForm.invalid// true
          //       } else {
          //         if (this.adjustDesiredForm.value.survivorSwitchAgeYears == this.adjustDesiredForm.value.clientAgeYears) {
          //           if (this.adjustDesiredForm.value.survivorSwitchAgeMonths < this.adjustDesiredForm.value.clientAgeMonths) {
          //             // true
          //           }
          //         }
          //       }
          //     }
          //   } else {
          //     if (this.isSurvivorBenefitFirstClaim) {
          //       if (this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears < this.adjustDesiredForm.value.spouseAgeYears) {
          //         // true
          //       } else {
          //         if (this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears == this.adjustDesiredForm.value.spouseAgeYears) {
          //           if (this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths < this.adjustDesiredForm.value.spouseAgeMonths) {
          //             // true
          //           }
          //         }
          //       }
          //     }
          //   }
            
          // }

          //If Already Claiming, wipe out validation and set values to be client current age
          this.clientAlreadyClaiming = this.data.clientProfile.SelfAlreadyCollecting;
          if(this.clientAlreadyClaiming){
            var currAge = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
            var currMonth = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);

            this.adjustDesiredForm.controls['clientAgeYears'].patchValue(currAge);
            this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(currMonth);

            this.adjustDesiredForm.get('clientAgeYears').setValidators([]);
            this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();

            this.adjustDesiredForm.get('clientAgeMonths').setValidators([]);
            this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();
          }

          if (this.data.clientProfile.Spouses.length) {
            this.spouseAlreadyClaiming = this.data.clientProfile.SpouseAlreadyCollecting;
            if(this.spouseAlreadyClaiming){
              var currAge = parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
              var currMonth = parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
  
              this.adjustDesiredForm.controls['spouseAgeYears'].patchValue(currAge);
              this.adjustDesiredForm.controls['spouseAgeMonths'].patchValue(currMonth);
  
              this.adjustDesiredForm.get('spouseAgeYears').setValidators([]);
              this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();
  
              this.adjustDesiredForm.get('spouseAgeMonths').setValidators([]);
              this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
            }
          }
          
          this.adjustDesiredForm.controls['isSurvivorShown'].patchValue(this.isShowSurvivorSection);
        });
  }

  resetValidation() {
    console.log('reset')
    if (!this.isSurvivorForClient) {
      if (this.isSpouseSurvivorBenefitFirstClaim) {
        console.log('isSpouseSurvivorBenefitFirstClaim');
        console.log('this.adjustDesiredForm', this.adjustDesiredForm)
        this.onSpouseSurvivorBenefit(this.adjustDesiredForm.value.spouseAgeYears);
        if (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) == 0) {
          console.log('this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears', this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears)
          this.adjustDesiredForm.controls['spouseSurvivorSwitchAgeYears'].clearValidators();
        } else {
          console.log('here i am 02')
          let expression = Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) - Number(this.adjustDesiredForm.value.spouseAgeYears);
          expression = expression < 0 ? -1 : (expression >0 ? 1: 0);
          console.log('expression', expression);
          switch(expression) {
            case -1:
              this.onSpouseRetirementBenefit(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears, 'year');
              break;
            case 0:
              if (this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths < this.adjustDesiredForm.value.spouseAgeMonths) {
                this.onSpouseRetirementBenefit(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths, 'month');
              };
              break;
          }
        }
      } else {
        if (Number(this.adjustDesiredForm.value.spouseAgeYears) == 0) {
          this.adjustDesiredForm.controls['spouseAgeYears'].clearValidators();
        } else {
          let expression = Number(this.adjustDesiredForm.value.spouseAgeYears) - Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears);
          expression = expression < 0 ? -1 : (expression >0 ? 1: 0);
          switch (expression) {
            case -1:
              this.onSpouseSurvivorBenefit(this.adjustDesiredForm.value.spouseAgeYears);
              break;
            case 0:
              if (this.adjustDesiredForm.value.spouseAgeMonths < this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) {
                this.onSpouseSurvivorBenefit(this.adjustDesiredForm.value.spouseAgeMonths);
              }
              break;
          }
        }

      }
    } else {
      if (this.isSurvivorBenefitFirstClaim) {
        if (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) == 0) {
          this.adjustDesiredForm.controls['survivorSwitchAgeYears'].clearValidators();
        } else {
          let expression = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) - Number(this.adjustDesiredForm.value.clientAgeYears);
          expression = expression < 0 ? -1 : (expression >0 ? 1: 0);
          switch(expression) {
            case -1:
              this.onRetirementBenefit(this.adjustDesiredForm.value.survivorSwitchAgeYears, 'year');
              break;
            case 0:
              if (this.adjustDesiredForm.value.survivorSwitchAgeMonths < this.adjustDesiredForm.value.clientAgeMonths) {
                this.onRetirementBenefit(this.adjustDesiredForm.value.survivorSwitchAgeMonths, 'month');
              };
              break;
          }
        }
      } else {
        if (Number(this.adjustDesiredForm.value.clientAgeYears) == 0) {
          this.adjustDesiredForm.controls['clientAgeYears'].clearValidators();
          this.adjustDesiredForm.controls['clientAgeMonths'].clearValidators();
          console.log('fell in this IF');
        } else {
          let expression = Number(this.adjustDesiredForm.value.clientAgeYears) - Number(this.adjustDesiredForm.value.survivorSwitchAgeYears);
          expression = expression < 0 ? -1 : (expression >0 ? 1: 0);
          switch(expression) {
            case -1:
              this.onSurvivorBenefit(this.adjustDesiredForm.value.clientAgeYears);
              break;
            case 0:
              if (this.adjustDesiredForm.value.clientAgeMonths < this.adjustDesiredForm.value.survivorSwitchAgeMonths) {
                this.onSurvivorBenefit(this.adjustDesiredForm.value.clientAgeMonths);
              };
              break;
          }
        }
      }

    }
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  close(update): void {
    if(update){
      this.dialogRef.close(this.adjustDesiredForm.value);
    } else {
      this.dialogRef.close();
    }
  }

  onChangeSaveDCA(){
    console.log('this.adjustDesiredForm 01', this.adjustDesiredForm);
    if(this.adjustDesiredForm.invalid){
      console.log('invalid form');
      return;
    };
    console.log('this.adjustDesiredForm 02', this.adjustDesiredForm);
    if (!this.isSurvivorForClient && this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears > 0) {
      console.log('here i am');
      this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears);
      this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths);

      //this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue((!this.adjustDesiredForm.value.swappedClaim) ? this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears : this.adjustDesiredForm.value.spouseAgeYears);
      //this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue((!this.adjustDesiredForm.value.swappedClaim) ? this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths : this.adjustDesiredForm.value.spouseAgeMonths);

      //this.adjustDesiredForm.controls['spouseAgeYears'].patchValue((!this.adjustDesiredForm.value.swappedClaim) ? this.adjustDesiredForm.value.spouseAgeYears : this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears);
      //this.adjustDesiredForm.controls['spouseAgeMonths'].patchValue((!this.adjustDesiredForm.value.swappedClaim) ? this.adjustDesiredForm.value.spouseAgeMonths : this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths);


      this.adjustDesiredForm.updateValueAndValidity();
    } 
    /* else {
      //survivor for Client
      if(!this.adjustDesiredForm.value.clientAgeYears && this.adjustDesiredForm.value.survivorSwitchAgeYears){
        this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.adjustDesiredForm.value.survivorSwitchAgeYears);
        this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.adjustDesiredForm.value.survivorSwitchAgeMonths);

        this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(0);
        this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(0);
      }
    } */

    if (!this.adjustDesiredForm.value.survivorSwitchAgeYears) {
      //this.adjustDesiredForm.get('swappedClaim').patchValue(false);
    } else {
      console.log('made it here 01');
      if ((Number(this.adjustDesiredForm.value.clientAgeYears) <= (this.adjustDesiredForm.value.survivorSwitchAgeYears) && this.isSurvivorForClient 
      || Number(this.adjustDesiredForm.value.spouseAgeYears) <= (this.adjustDesiredForm.value.survivorSwitchAgeYears) && !this.isSurvivorForClient)){
        if(!this.adjustDesiredForm.value.clientAgeYears){
          //this.adjustDesiredForm.controls['clientAgeYears'].patchValue(this.adjustDesiredForm.value.survivorSwitchAgeYears);
          //this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(this.adjustDesiredForm.value.survivorSwitchAgeMonths);
          //this.adjustDesiredForm.get('swappedClaim').patchValue(true);
        } else {
          //this.adjustDesiredForm.get('swappedClaim').patchValue(false);
        }

        console.log('made it here 01');
      } else {
        //this.adjustDesiredForm.get('swappedClaim').patchValue(true);
      }
    }
    console.log('made it here 02');
    console.log('this.scenario', this.scenario);

    if(this.adjustDesiredForm.value.clientAgeYears){
      if(this.adjustDesiredForm.value.clientAgeMonth ==  ''){
        this.adjustDesiredForm.value.clientAgeMonth = 0;
      }
      if(this.data.clientProfile.Spouses[0].maritalStatus != 'Single' 
      && this.data.clientProfile.Spouses[0].maritalStatus != 'Widowed' && this.data.clientProfile.IsLegalSpouse){
        if(this.adjustDesiredForm.value.spouseAgeMonths ==  ''){
          this.adjustDesiredForm.value.spouseAgeMonths = 0;
        }
      }
    }

    let isWidowSurvivorCase = false;
    let isAliveTenYrs = this.data.clientProfile.Spouses[1] ? this.data.clientProfile.Spouses[0].maritalStatus == 'Single' && !this.data.clientProfile.Spouses[1].alive && this.data.clientProfile.Spouses[1].tenyears: false;
    if (this.scenario == 'Alternate' && (this.data.clientProfile.Spouses[0].maritalStatus == 'Widowed' || isAliveTenYrs) && this.adjustDesiredForm.value.swappedClaim)
      isWidowSurvivorCase = true;

    if(this.scenario == 'FRA' || this.scenario == 'First Alternate' || this.scenario == 'First Alternate (Retroactive File)'){
      if(this.adjustDesiredForm.value.clientAgeYears || this.adjustDesiredForm.value.survivorSwitchAgeYears){
        this.close(true);
      } else {
        this.close(false);
      }

    } else {

      if(this.adjustDesiredForm.value.clientAgeYears || (isWidowSurvivorCase || this.adjustDesiredForm.value.survivorSwitchAgeYears)){
        /* if(this.adjustDesiredForm.value.clientAgeMonth ==  ''){
          this.adjustDesiredForm.value.clientAgeMonth = 0;
        }
        if(this.data.clientProfile.Spouses[0].maritalStatus != 'Single' && this.data.clientProfile.Spouses[0].maritalStatus != 'Widowed' && this.data.clientProfile.IsLegalSpouse){
          if(this.adjustDesiredForm.value.spouseAgeMonths ==  ''){
            this.adjustDesiredForm.value.spouseAgeMonths = 0;
          }
        } */


        /* if (this.dataFromModalAdjust.clientAgeYears && this.dataFromModalAdjust.survivorSwitchAgeYears 
          && this.swapClaimWasToggled && this.isSurvivorForClient && this.isSurvivorBenefitFirstClaim) {
          if (Number(this.dataFromModalAdjust.survivorSwitchAgeYears) <= (this.dataFromModalAdjust.clientAgeYears)) {
            //this.isSurvivorBenefitFirstClaim = false;
            //console.log('here i am bb');
            this.adjustDesiredForm.controls['swappedClaim'].patchValue(false);

            var surY = this.adjustDesiredForm.value.clientAgeYears;
            var surM = this.adjustDesiredForm.value.clientAgeMonths;
            var retY = this.adjustDesiredForm.value.survivorSwitchAgeYears;
            var retM = this.adjustDesiredForm.value.survivorSwitchAgeMonths;

            this.adjustDesiredForm.controls['clientAgeYears'].patchValue(surY);
            this.adjustDesiredForm.controls['clientAgeMonths'].patchValue(surM);
            this.adjustDesiredForm.controls['survivorSwitchAgeYears'].patchValue(retY);
            this.adjustDesiredForm.controls['survivorSwitchAgeMonths'].patchValue(retM);

          } else {
           
            //this.adjustDesiredForm.controls['swappedClaim'].patchValue(false);
          }
        } */

        //TODO: fix that the messages will only display if a user actually saves something/changes DCA
        //if(!this.adjustDesiredForm.value.displayedDCAToggleOnMessage){
          if(this.adjustDesiredForm.value.saveDCA && !this.adjustDesiredForm.value.displayedDCAToggleOnMessage){
            
      console.log('Modal Close', this.adjustDesiredForm);
            const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
              data: { title: 'Notification!', 
              btnNoTitle: 'Do Not Save to Profile',
              btnYesTitle: 'Save to Profile',
              question: 'You have selected to save ' + ((this.data.spouseAgeYears) ? + 'these claim ages' : 'this claim age') + ' to the Client Profile.<br/>You can always edit ' + ((this.data.spouseAgeYears) ? + 'these' : 'this') + ' by visiting the Client Hub.' }
            });
        
            dialogRef.afterClosed().subscribe(result => {
              this.adjustDesiredForm.controls["saveDCA"].patchValue(result);
              this.adjustDesiredForm.controls["displayedDCAToggleOnMessage"].patchValue(true);  
              this.dialogRef.close(this.adjustDesiredForm.value);      
            });     
          } else if(!this.adjustDesiredForm.value.saveDCA && !this.adjustDesiredForm.value.displayedDCAToggleOffMessage) {
            const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
              data: { title: 'Notification!', 
              btnNoTitle: 'Do Not Save to Profile',
              btnYesTitle: 'Save to Profile',
              question: ((this.data.spouseAgeYears) ? + 'These claim ages' : 'This claim age') + ' will not be saved to the Client Profile,<br/>but will appear in the illustration currently being run.' }
            });
        
            dialogRef.afterClosed().subscribe(result => {
              this.adjustDesiredForm.controls["saveDCA"].patchValue(result);
              this.adjustDesiredForm.controls["displayedDCAToggleOffMessage"].patchValue(true);
              this.dialogRef.close(this.adjustDesiredForm.value);
            });  
          } else {
            this.close(true);
          }
        //}
      } else {
        this.close(false);
      }
    }
  }

  onChangeFileRestricted(value, type){

    this.adjustDesiredForm.get("fileRestrictedAgeYears").setValidators([Validators.min(69), Validators.max(69)]);
    this.adjustDesiredForm.get("fileRestrictedAgeMonths").setValidators([Validators.min(this.minFileRestrictedMonths), Validators.max(11)]);

    //if spouse included    
    this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").setValidators([Validators.min(69), Validators.max(69)]);
    this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").setValidators([Validators.min(this.minSpouseFileRestrictedClaimMonths), Validators.max(11)]);


    //if one is filled in, the other is now required
    if (this.adjustDesiredForm.get("fileRestrictedAgeMonths").value){
      this.adjustDesiredForm.get("fileRestrictedAgeYears").setValidators([Validators.required, Validators.min(69), Validators.max(69)]);
    } else if (this.adjustDesiredForm.get("fileRestrictedAgeYears").value){
      this.adjustDesiredForm.get("fileRestrictedAgeMonths").setValidators([Validators.required, Validators.min(this.minFileRestrictedMonths), Validators.max(11)]);
    } else {
      this.adjustDesiredForm.get("fileRestrictedAgeMonths").reset();
      this.adjustDesiredForm.get("fileRestrictedAgeMonths").clearValidators();   

      this.adjustDesiredForm.get("fileRestrictedAgeYears").reset();
      this.adjustDesiredForm.get("fileRestrictedAgeYears").clearValidators();   
    }

    if (this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").value){
      this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").setValidators([Validators.required, Validators.min(69), Validators.max(69)]);
    } else if (this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").value){
      this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").setValidators([Validators.required, Validators.min(this.minSpouseFileRestrictedClaimMonths), Validators.max(11)]);
    } else {
      this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").reset();
      this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").clearValidators();   

      this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").reset();
      this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").clearValidators();   
    }

    
    this.adjustDesiredForm.get("fileRestrictedAgeYears").updateValueAndValidity();
    this.adjustDesiredForm.get("fileRestrictedAgeMonths").updateValueAndValidity();

    this.adjustDesiredForm.get("spouseFileRestrictedAgeYears").updateValueAndValidity();
    this.adjustDesiredForm.get("spouseFileRestrictedAgeMonths").updateValueAndValidity();


    if(this.isClientFilingRestricted){
      var year = (type == 'year') ? value : this.adjustDesiredForm.value.fileRestrictedAgeYears;
      var month = (type == 'month') ? value : this.adjustDesiredForm.value.fileRestrictedAgeMonths;

      if(this.adjustDesiredForm.value.clientAgeYears == year && year == 69){
        if(this.adjustDesiredForm.value.clientAgeMonths < month){
          this.adjustDesiredForm.get('clientAgeMonths').reset();          
          this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();
        }        
      } 
    }

    if(this.isSpouseFilingRestricted){
      var year = (type == 'year') ? value : this.adjustDesiredForm.value.spouseFileRestrictedAgeYears;
      var month = (type == 'month') ? value : this.adjustDesiredForm.value.spouseFileRestrictedAgeMonths;

      if(this.adjustDesiredForm.value.spouseAgeYears == year && year == 69){
        if(this.adjustDesiredForm.value.spouseAgeMonths < month){
          this.adjustDesiredForm.get('spouseAgeMonths').reset();
          this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
        }
      } 
    }

  }

  // onSurvivorBenefit(value){
  //   console.log('here i am 01', this.isSurvivorBenefitFirstClaim);
  //   if (this.isSurvivorBenefitFirstClaim && this.isShowSurvivorSection) {
  //       // Survivor Benefits are first claim and Retirement Benefits are second claim
  //       let clientAge = this.calculateAge(this.data.client.DOB);
  //       this.minClaimAge =clientAge > 60 ? clientAge : 60;
  //       console.log('minClaimAge 05', this.minClaimAge);
  //       this.maxClaimAge = (this.isSurvivorForClient) ? 69 : 70;
  //       this.maxClientClaimMonths = (this.adjustDesiredForm.value.clientAgeYears == 70) ? 0 : 11;
  //       this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
  //       this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();
  //       this.minClientClaimMonths = 0;
  //       console.log('this.minClientClaimMonths zss 01', this.minClientClaimMonths);
  //       this.adjustDesiredForm.get("clientAgeMonths").setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
  //       this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();
        
  //     if (this.adjustDesiredForm.value.survivorSwitchAgeYears) {
  //       let clientAge = this.calculateAge(this.data.client.DOB);
  //       this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
  //       this.minSurvivorSwitchClaimAge = Number(this.adjustDesiredForm.value.clientAgeYears) > this.minSurvivorSwitchClaimAge ? (Number(this.adjustDesiredForm.value.clientAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.clientAgeYears) + 1 : Number(this.adjustDesiredForm.value.clientAgeYears)):this.minSurvivorSwitchClaimAge;
  //       this.maxSurvivorSwitchClaimAge = 70;
  //       this.maxSurvivorSwitchClaimMonths = 0;
  //       this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
  //       this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
  //       let clientAgeMonths = Number(this.adjustDesiredForm.get('clientAgeMonths').value || 0);
  //       this.minSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) == 70 || Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > Number(this.adjustDesiredForm.value.clientAgeYears) ? 0: 
  //                                           (Number(this.adjustDesiredForm.value.clientAgeYears) > 0 ? (clientAgeMonths < 11 ? Number(this.adjustDesiredForm.value.clientAgeMonth) + 1:clientAgeMonths): 0);
  //       console.log('this.minSurvivorSwitchClaimMonths', this.minSurvivorSwitchClaimMonths)
  //       this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
  //       this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
  //     }
  //   } else {
  //     // Retirement benefit first and Survivir Benefits are second
  //     if(!this.isClientAgeReadOnly){
  //       console.log('here i am 03');
  //       let clientAge = this.calculateAge(this.data.client.DOB);
  //       let minClaimAge = clientAge >= 62 ? clientAge : 62;
  //       console.log('minClaimAge 06', this.minClaimAge);
  //       this.minClaimAge = (this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge) ? this.minRetroFileClaimAge : Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeYears)): minClaimAge;
  //       console.log('this.minClaimAge', this.minClaimAge);
  //       this.maxClaimAge = 70;
  //       this.maxClientClaimMonths = (Number(this.adjustDesiredForm.value.clientAgeYears) == 70) ? 0 : 11;
  //       this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
  //       this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();

  //       console.log('do we have this.minRetroFileClaimMonths', this.minRetroFileClaimMonths);
  //       this.minClientClaimMonths = (this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge && this.minRetroFileClaimMonths) ? this.minRetroFileClaimMonths : Number(this.adjustDesiredForm.value.clientAgeYears) == 70 || Number(this.adjustDesiredForm.value.clientAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
                
  //       console.log('this.minClientClaimMonths 002', this.minRetroFileClaimMonths);
  //       this.adjustDesiredForm.get("clientAgeMonths").setValidators((this.minClientClaimMonths > 0) ? [Validators.required, Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)] : [Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
  //       this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();

  //       if(this.adjustDesiredForm.value.clientAgeYears == 70){
  //         this.adjustDesiredForm.get("clientAgeMonths").markAsTouched();
  //       }
  //     }

  //     if(!this.isSpouseAgeReadOnly){
  //       //if(this.adjustDesiredForm.value.spouseAgeYears){
  //       if(this.spouseMinClaimAge && this.adjustDesiredForm.value.spouseAgeYears){
          
  //         this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
  //         this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
          
  //         console.log('this.minSpouseRetroFileClaimAge', this.minSpouseRetroFileClaimAge);
  //         console.log('this.minSpouseRetroFileClaimMonths', this.minSpouseRetroFileClaimMonths);
  //         console.log('this.adjustDesiredForm.value.spouseAgeYears', this.adjustDesiredForm.value.spouseAgeYears);
  //         this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;//Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
  //         this.minSpouseClaimMonths = (this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge && this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : 0;//(Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
  //         console.log('this.minSpouseClaimMonths 00009', this.minSpouseClaimMonths);
          
  //         //if(!this.minSpouseRetroFileClaimMonths){
  //           this.minSpouseClaimMonths = this.adjustDesiredForm.value.spouseAgeYears > 62 && this.calculateAge(this.data.clientProfile.Spouses[0].dob) == this.adjustDesiredForm.value.spouseAgeYears ? (this.getDOBMonth(this.data.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) ? (new Date().getMonth() + 1) : ((new Date().getMonth() + 1) - this.getDOBMonth(this.data.clientProfile.Spouses[0].dob)) : this.minSpouseClaimMonths;
  //         //}

  //         this.adjustDesiredForm.get("spouseAgeMonths").setValidators((this.minSpouseClaimMonths > 0) ? [Validators.required, Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)] : [Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
  //         this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();

  //         //if(this.adjustDesiredForm.value.spouseAgeYears == 70){
  //           this.adjustDesiredForm.get("spouseAgeMonths").markAsTouched();
  //         //}
  //       }
  //     }

  //   }

  // }

  onSurvivorBenefit(value){
    console.log('onSurvivorBenefit', this.isSurvivorBenefitFirstClaim);
    console.log('this.maxSurvivorSwitchClaimAge', this.maxSurvivorSwitchClaimAge);
    // let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
    let clientDOBMonth = new Date (this.data.client.DOB).getMonth() + 1;
    // let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
    // // let clientMonthIndex = spouseDOBMonth < clientDOBMonth ? 1 : 0;
    // // let clientMonthIndex = clientDOBMonth == 1 ? 1 : clientDOBMonth <= new Date().getMonth() ? 0 : 1;
    // // let clientMonthIndex = spouseDOBMonth < clientDOBMonth ? 1 : 0;
    let clientAge = this.calculateAge(this.data.client.DOB);
    // let clientRemainingYear = this.data.clientProfile.LifeExpectancy - clientAge;
    // let spouseMonthIndex = spouseDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
    // let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - (spouseAge + spouseMonthIndex);
    // let clientMinClaimAge = clientRemainingYear > spouseRemainingYear && this.isShowSurvivorSection ? clientAge + spouseRemainingYear  : 0;
    let clientMinClaimAge = this.getClientMinClaimAge();
    let minClientClaimAge = clientAge > 60 ? clientAge : 60;
    var currAge = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
    var currMonth = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
    if (this.isSurvivorBenefitFirstClaim && this.isShowSurvivorSection) {
        // Survivor Benefits are first claim and Retirement Benefits are second claim
        // let clientAge = this.calculateAge(this.data.client.DOB);
        // this.minClaimAge =clientAge > 60 ? clientAge : 60;
        // console.log('minClaimAge 05', this.minClaimAge);
        // this.maxClaimAge = (this.isSurvivorForClient) ? 69 : 70;
        // this.maxClientClaimMonths = (this.adjustDesiredForm.value.clientAgeYears == 70) ? 0 : 11;
        // this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
        // this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();
        // this.minClientClaimMonths = 0;
        // console.log('this.minClientClaimMonths zss 01', this.minClientClaimMonths);
        // this.adjustDesiredForm.get("clientAgeMonths").setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
        // this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();
        console.log('minClaimAge 05', this.spouseMinClaimAge);
        this.maxClaimAge = Math.min(70, this.data.clientProfile.LifeExpectancy);
        // this.maxClaimAge = (this.isSurvivorForClient) ? 69 : 70;
        // let clientMaxClaimAge = (this.isSurvivorForClient) ? 69 : 70;
        // this.maxClaimAge = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) + 1: (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) == 0 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) - 1: Number(this.adjustDesiredForm.value.survivorSwitchAgeYears)) ): clientMaxClaimAge;
        console.log('this.maxClaimAge', this.maxClaimAge);
        console.log('this.data', this.data)
        this.minClaimAge = clientMinClaimAge > minClientClaimAge && clientMinClaimAge < 70 ? clientMinClaimAge : minClientClaimAge;
        // this.maxClaimAge = this.maxClaimAge > this.minClaimAge ? this.maxClaimAge : clientMaxClaimAge;

        console.log('this.spouseMinClaimAge', this.spouseMinClaimAge);
        console.log('this.minSpouseSurvivorSwitchClaimAge', this.minSpouseSurvivorSwitchClaimAge)

        // this.maxClientClaimMonths = (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) == 0 ? 11 : (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 12 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) - 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 11);
        // this.maxClientClaimMonths = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 && Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > Number(this.adjustDesiredForm.value.clientAgeYears) ? 11 : this.maxClientClaimMonths;
        this.maxClientClaimMonths = Number(this.adjustDesiredForm.value.clientAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.clientAgeYears || 0) != 0  ? 11 : 0;
        this.minClientClaimMonths = 0;
        console.log('value', value);
        console.log('clientMinClaimAge', clientMinClaimAge);
        let userProvidedSurvivorAge = Number(this.adjustDesiredForm.value.clientAgeYears || 0);
        if(!this.isClientRetroFiling){
          console.log('does not have retro 8');
          this.minClientClaimMonths = clientMinClaimAge > minClientClaimAge && clientMinClaimAge < 70 && userProvidedSurvivorAge == this.minClaimAge && this.minClaimAge == clientMinClaimAge ? clientDOBMonth == 1 ? 0: (13 - clientDOBMonth): this.minClientClaimMonths;        
          this.minClientClaimMonths = clientAge >= 62 && clientAge == Number(this.adjustDesiredForm.value.clientAgeYears || 0) ? currMonth : this.minClientClaimMonths;
        } else {
          this.minClaimAge = this.minRetroFileClaimAge;
          this.minClientClaimMonths = (this.minRetroFileClaimAge == Number(this.adjustDesiredForm.value.clientAgeYears || 0)) ? this.minRetroFileClaimMonths : 0;
          console.log('retro months', this.minRetroFileClaimMonths);
        }
        // this.maxSpouseClaimMonths = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 && value == spouseMinClaimAge && this.maxSpouseClaimMonths < this.minSpouseClaimMonths ? 11: this.maxSpouseClaimMonths;
        this.maxClientClaimMonths = clientMinClaimAge > minClientClaimAge && clientMinClaimAge < 70 ? 11: this.maxClientClaimMonths;
        console.log('this.minClientClaimMonths zss 01', this.minClientClaimMonths);

        
      if (this.adjustDesiredForm.value.survivorSwitchAgeYears) {
        this.maxClaimAge = Math.min(69, this.data.clientProfile.LifeExpectancy);
        this.maxClientClaimMonths = 11;
        this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
        this.minSurvivorSwitchClaimAge = Number(this.adjustDesiredForm.value.clientAgeYears) > this.minSurvivorSwitchClaimAge 
        ? (Number(this.adjustDesiredForm.value.clientAgeMonths) == 11 
        ? Number(this.adjustDesiredForm.value.clientAgeYears) + 1 
        : Number(this.adjustDesiredForm.value.clientAgeYears))
        : this.minSurvivorSwitchClaimAge;

        this.maxSurvivorSwitchClaimAge = 70;
        this.maxSurvivorSwitchClaimMonths = 0;
        this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
        this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
        let clientAgeMonths = Number(this.adjustDesiredForm.get('clientAgeMonths').value || 0);
        this.minSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) == 70 || Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > Number(this.adjustDesiredForm.value.clientAgeYears) ? 0: 
                                            (Number(this.adjustDesiredForm.value.clientAgeYears) > 0 ? (clientAgeMonths < 11 ? Number((this.adjustDesiredForm.value.clientAgeMonth ? this.adjustDesiredForm.value.clientAgeMonth : 0)) + 1 : clientAgeMonths) : 0);
        console.log('this.minSurvivorSwitchClaimMonths', this.minSurvivorSwitchClaimMonths)
        this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max((this.maxSurvivorSwitchClaimMonths) ? this.maxSurvivorSwitchClaimMonths : 11)]);
        this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();       
      }

      //if (this.adjustDesiredForm.value.clientAgeYears) {
        this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
        this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();
        this.adjustDesiredForm.get("clientAgeMonths").setValidators((this.minClientClaimMonths) 
          ? [Validators.required, Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)] 
          : [Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
        this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();
        this.adjustDesiredForm.get("clientAgeMonths").markAsTouched();
      //} else {
      //  this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();
      //}

    } else {
      // Retirement benefit first and Survivir Benefits are second
      if(!this.isClientAgeReadOnly){
        console.log('here i am 03 client');
        let clientAge = this.calculateAge(this.data.client.DOB);
        let minClaimAge = clientAge >= 62 ? clientAge : 62;
        console.log('minClaimAge 06', this.minClaimAge);
        if (this.isShowSurvivorSection) {
          let minimumClientClaimAge  = (this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge) 
            ? this.minRetroFileClaimAge 
            : Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 
            ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) == 11 
            ? Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) + 1 
            : Number(this.adjustDesiredForm.value.survivorSwitchAgeYears)) 
            : minClaimAge;
          console.log('minimumClientClaimAge', minimumClientClaimAge);
          console.log('clientMinClaimAge', clientMinClaimAge);
          this.minClaimAge = clientMinClaimAge > minimumClientClaimAge ? clientMinClaimAge : minimumClientClaimAge;
          this.minClientClaimMonths = (this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge && this.minRetroFileClaimMonths) 
            ? this.minRetroFileClaimMonths 
            : Number(this.adjustDesiredForm.value.clientAgeYears) == 70 || Number(this.adjustDesiredForm.value.clientAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) 
            ? (currMonth > 0 && this.adjustDesiredForm.value.clientAgeYears == currAge) ? currMonth : 0 
            : (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 
            ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 
            ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1 
            : Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)) : 0);
          console.log('min client months 03', this.minClientClaimMonths);
          this.minClientClaimMonths = clientMinClaimAge > minimumClientClaimAge 
            && Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 
            && this.adjustDesiredForm.value.clientAgeYears == clientMinClaimAge 
            ? clientDOBMonth == 1 
            ? 0 : (13 - clientDOBMonth) 
            : this.minClientClaimMonths;
          console.log('min client months 03', this.minClientClaimMonths);
        } else {
          minClientClaimAge = clientAge > 62 ? clientAge : 62;
          this.minClaimAge = (this.minRetroFileClaimAge) ? this.minRetroFileClaimAge : minClaimAge;
          let clientAgeMonth = new Date().getMonth() + 1 > clientDOBMonth ? new Date().getMonth() + 1 - clientDOBMonth : new Date().getMonth() + 1 == clientDOBMonth ? 0 : clientDOBMonth - new Date().getMonth() + 1;
          console.log('clientAgeMonth', clientAgeMonth);
          console.log('this.minRetroFileClaimMonths', this.minRetroFileClaimMonths);
          console.log('this.minRetroFileClaimAge', this.minRetroFileClaimAge);
          console.log('this.adjustDesiredForm.value.clientAgeYears', this.adjustDesiredForm.value.clientAgeYears)
          this.minClientClaimMonths = clientAge > 62 ? ((this.adjustDesiredForm.value.clientAgeYears == this.minRetroFileClaimAge && this.minRetroFileClaimMonths) ? this.minRetroFileClaimMonths : (this.adjustDesiredForm.value.clientAgeYears == this.minClaimAge) ? clientAgeMonth : 0) : 0;
        }

        console.log('this.minClaimAge', this.minClaimAge);
        this.maxClaimAge = Math.min(70, this.data.clientProfile.LifeExpectancy);
        this.maxClientClaimMonths = (Number(this.adjustDesiredForm.value.clientAgeYears) == 70) ? 0 : 11;
        if(this.isSurvivorBenefitFirstClaim){
          this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
        } else {
          if(!this.isSurvivorForClient){
            this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          } else {
            this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          }
        }
        this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();

        console.log('do we have this.minRetroFileClaimMonths', this.minRetroFileClaimMonths);

                
        console.log('this.minClientClaimMonths 002', this.minRetroFileClaimMonths);
        console.log('this.minClientClaimMonths 002', this.minClientClaimMonths);
       /*  if(this.isSurvivorBenefitFirstClaim){
          this.adjustDesiredForm.get("clientAgeMonths").setValidators((this.minClientClaimMonths > 0) ? [Validators.required, Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)] : [Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
        } else {
          this.adjustDesiredForm.get("clientAgeMonths").setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
        } */
        if(((this.isClientRetroFiling && !this.isShowSurvivorSection) || (this.isClientRetroFiling && this.isShowSurvivorSection && this.isSurvivorBenefitFirstClaim)) && Number(this.adjustDesiredForm.value.clientAgeYears) <= this.minRetroFileClaimAge){
          this.minClientClaimMonths = this.minRetroFileClaimMonths;         
        }

        if(Number(this.adjustDesiredForm.value.clientAgeYears) == 70){
          this.minClientClaimMonths = 0;
        }
        this.minClientClaimMonths = value || this.adjustDesiredForm.value.clientAgeYears ? this.minClientClaimMonths : 0;
        this.maxClientClaimMonths = value || this.adjustDesiredForm.value.clientAgeYears ? this.maxClientClaimMonths : 0;
        this.adjustDesiredForm.get("clientAgeMonths").setValidators((this.minClientClaimMonths > 0) 
          ? [Validators.required, Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)] 
          : [Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
        this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();

        if(this.adjustDesiredForm.value.clientAgeYears == 70){
          this.adjustDesiredForm.get("clientAgeMonths").markAsTouched();
        }

        if (this.isShowSurvivorSection && this.isSurvivorForClient) {
          this.maxSurvivorSwitchClaimAge = Number(this.adjustDesiredForm.value.clientAgeYears)  == 70 ? 69: this.maxSurvivorSwitchClaimAge;
          this.maxSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.clientAgeYears)  == 70 ? 11: this.maxSurvivorSwitchClaimMonths;
          console.log('this.minClaimAge xxx', this.minClaimAge);
          //this.minClaimAge = (this.adjustDesiredForm.value.survivorSwitchAgeYears == this.minRetroFileClaimAge && !this.isSurvivorBenefitFirstClaim) ? this.minRetroFileClaimAge  : this.minClaimAge;
          this.minSurvivorSwitchClaimAge = (this.minRetroFileClaimAge && !this.isSurvivorBenefitFirstClaim) ? this.minRetroFileClaimAge  : this.minSurvivorSwitchClaimAge;
          console.log('this.minClaimAge xxx2', this.minClaimAge);
          this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.required, Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
          this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
          this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
          this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();

          this.adjustDesiredForm.get("survivorSwitchAgeYears").markAsTouched();
          if(!this.isSurvivorBenefitFirstClaim){
            this.adjustDesiredForm.get("clientAgeMonths").markAsTouched();
          }
        } else {
          
            /* this.adjustDesiredForm.get('survivorSwitchAgeYears').reset();
            this.adjustDesiredForm.get('survivorSwitchAgeYears').clearValidators();
            this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();

            this.adjustDesiredForm.get('survivorSwitchAgeMonths').reset();
            this.adjustDesiredForm.get('survivorSwitchAgeMonths').clearValidators();
            this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity(); */
          
        }

        
      }

      if(!this.isSpouseAgeReadOnly){
        //if(this.adjustDesiredForm.value.spouseAgeYears){
        if(this.spouseMinClaimAge && this.adjustDesiredForm.value.spouseAgeYears){
          var targetYear = "spouseAgeYears";
          var targetMonth = "spouseAgeMonths";
          /* if(!this.isSurvivorForClient && !this.isSurvivorBenefitFirstClaim){
            targetYear = "spouseSurvivorSwitchAgeYears";
            targetMonth = "spouseSurvivorSwitchAgeMonths";
          } */
          //if(this.isSurvivorForClient){
            let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
            let minSpouseClaimAge = spouseAge > 60 ? spouseAge : 60;

            console.log('this.spouseMinClaimAge 0009', this.spouseMinClaimAge);
            console.log('this.spouseMinClaimAge 0009', minSpouseClaimAge);
            console.log('this.maxClaimAge 0009', this.maxClaimAge);

            this.adjustDesiredForm.get(targetYear).setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
            this.adjustDesiredForm.get(targetYear).updateValueAndValidity();
            
            console.log('this.minSpouseRetroFileClaimAge', this.minSpouseRetroFileClaimAge);
            console.log('this.minSpouseRetroFileClaimMonths', this.minSpouseRetroFileClaimMonths);
            console.log('this.adjustDesiredForm.value.spouseAgeYears', this.adjustDesiredForm.value.spouseAgeYears);
            this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.get(targetYear).value) == 70) ? 0 : 11;//Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
            this.minSpouseClaimMonths = (this.adjustDesiredForm.get(targetYear).value == this.minSpouseRetroFileClaimAge 
              && this.minSpouseRetroFileClaimMonths) 
              ? this.minSpouseRetroFileClaimMonths : 0;//(Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
            console.log('this.minSpouseClaimMonths 00009 - client', this.minSpouseClaimMonths);

            if(!this.minSpouseRetroFileClaimMonths){              
              this.minSpouseClaimMonths = this.adjustDesiredForm.get(targetYear).value > 62 
                && this.calculateAge(this.data.clientProfile.Spouses[0].dob) == this.adjustDesiredForm.get(targetYear).value 
                ? (this.getDOBMonth(this.data.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) 
                ? this.minSpouseClaimMonths 
                : ((new Date().getMonth() + 1) - this.getDOBMonth(this.data.clientProfile.Spouses[0].dob)) 
                : this.minSpouseClaimMonths;
            }

            this.adjustDesiredForm.get(targetMonth).setValidators((this.minSpouseClaimMonths) 
              ? [Validators.required, Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)] 
              : [Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
            this.adjustDesiredForm.get(targetMonth).updateValueAndValidity();

            //if(this.adjustDesiredForm.value.spouseAgeYears == 70){
              this.adjustDesiredForm.get(targetMonth).markAsTouched();
            //}
          //}
          /* if(!this.isSurvivorForClient && !this.isSurvivorBenefitFirstClaim){
            this.adjustDesiredForm.get('spouseAgeYears').reset();
            this.adjustDesiredForm.get('spouseAgeYears').clearValidators();
            this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();

            this.adjustDesiredForm.get('spouseAgeMonths').reset();
            this.adjustDesiredForm.get('spouseAgeMonths').clearValidators();
            this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
          } */
        }

        if(!this.isSurvivorForClient && !this.isSpouseSurvivorBenefitFirstClaim){
          var targetYear = "spouseSurvivorSwitchAgeYears";
          var targetMonth = "spouseSurvivorSwitchAgeMonths";
         
          // this.adjustDesiredForm.get(targetYear).setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
          this.adjustDesiredForm.get(targetYear).setValidators([Validators.required, Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxClaimAge)]);
          
          this.adjustDesiredForm.get(targetYear).updateValueAndValidity();
            
            console.log('this.minSpouseRetroFileClaimAge', this.minSpouseRetroFileClaimAge);
            console.log('this.minSpouseRetroFileClaimMonths', this.minSpouseRetroFileClaimMonths);
            console.log('this.adjustDesiredForm.value.spouseAgeYears', this.adjustDesiredForm.value.spouseAgeYears);
            this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.get(targetYear).value) == 70) ? 0 : 11;//Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
            this.minSpouseClaimMonths = (this.adjustDesiredForm.get(targetYear).value == this.minSpouseRetroFileClaimAge 
              && this.minSpouseRetroFileClaimMonths) 
              ? this.minSpouseRetroFileClaimMonths : 0;//(Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
            console.log('this.minSpouseClaimMonths 00009 - client', this.minSpouseClaimMonths);
            
            if(!this.minSpouseRetroFileClaimMonths){
              this.minSpouseClaimMonths = this.adjustDesiredForm.get(targetYear).value > 62 
                && this.calculateAge(this.data.clientProfile.Spouses[0].dob) == this.adjustDesiredForm.get(targetYear).value 
                ? (this.getDOBMonth(this.data.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) 
                ? (new Date().getMonth() + 1) 
                : ((new Date().getMonth() + 1) - this.getDOBMonth(this.data.clientProfile.Spouses[0].dob)) 
                : this.minSpouseClaimMonths;
            }

            this.adjustDesiredForm.get(targetMonth).setValidators((this.minSpouseClaimMonths) 
              ? [Validators.required, Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)] 
              : [Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
            this.adjustDesiredForm.get(targetMonth).updateValueAndValidity();

            //if(this.adjustDesiredForm.value.spouseAgeYears == 70){
              this.adjustDesiredForm.get(targetMonth).markAsTouched();
            //}

          this.adjustDesiredForm.get('spouseAgeYears').reset();
          this.adjustDesiredForm.get('spouseAgeYears').clearValidators();
          this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();

          this.adjustDesiredForm.get('spouseAgeMonths').reset();
          this.adjustDesiredForm.get('spouseAgeMonths').clearValidators();
          this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
        }
      }

      /* if(!this.adjustDesiredForm.value.survivorSwitchAgeYears) {
        this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
        this.adjustDesiredForm.get("survivorSwitchAgeYears").markAsTouched();
      } */

    }

    console.log('form validation check', this.adjustDesiredForm);

    console.log('this.maxSurvivorSwitchClaimAge 02', this.maxSurvivorSwitchClaimAge);
  }

  onSpouseSurvivorBenefit(value) {
    console.log('onSpouseSurvivorBenefit', this.isSpouseSurvivorBenefitFirstClaim);
    let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
    let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
    // console.log('spouseDOBMonth', spouseDOBMonth);
    // console.log('isShowSurvivorSection', this.isShowSurvivorSection)
    // // let spouseMonthIndex = spouseDOBMonth == 1 ? 1 : spouseDOBMonth <= new Date().getMonth() ? 0 : 1;
    // let clientAge = this.calculateAge(this.data.client.DOB);
    // let clientDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
    // let clientMonthIndex = clientDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
    // let clientRemainingYear = this.data.clientProfile.LifeExpectancy - (clientAge + clientMonthIndex);
    // let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - spouseAge;
    // let spouseMinClaimAge = spouseRemainingYear > clientRemainingYear && this.isShowSurvivorSection ? spouseAge + clientRemainingYear  : 0;
    let spouseMinClaimAge = this.getSpouseMinClaimAge();
    console.log('check spouse min DCA', spouseMinClaimAge);
    let minSpouseClaimAge = spouseAge > 60 ? spouseAge : 60;
    console.log('minClaimAge 04', minSpouseClaimAge);
    if (this.isSpouseSurvivorBenefitFirstClaim) {
        // Survivor Benefits are first claim and Retirement Benefits are second claim
        console.log('minClaimAge 05', this.spouseMinClaimAge);
        console.log('this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears', this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears);
        this.spouseMaxClaimAge = Math.min(70, this.data.clientProfile.Spouses[0].LifeExpectancy);
        // let spouseMaxClaimAge = 69;
        // this.spouseMaxClaimAge = Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) + 1: (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) == 0 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) - 1: Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears)) ): spouseMaxClaimAge;
        console.log('this.spouseMaxClaimAge', this.spouseMaxClaimAge);
        console.log('this.data', this.data)
        this.spouseMinClaimAge = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 //&& spouseAge >= spouseMinClaimAge
          ? spouseMinClaimAge 
          : minSpouseClaimAge;

        // this.spouseMaxClaimAge = this.spouseMaxClaimAge > this.spouseMinClaimAge ? this.spouseMaxClaimAge : spouseMaxClaimAge;
        // this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
        // this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
        console.log('this.spouseMinClaimAge', this.spouseMinClaimAge);
        console.log('this.minSpouseSurvivorSwitchClaimAge', this.minSpouseSurvivorSwitchClaimAge)
        this.maxSpouseClaimMonths = Number(this.adjustDesiredForm.value.spouseAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.spouseAgeYears || 0) != 0  ? 11 : 0;
        // this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) == 0 ? 11 : (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) < 12 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) - 1:Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths)): 11);
        // this.maxSpouseClaimMonths = Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 && Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > Number(this.adjustDesiredForm.value.spouseAgeYears) ? 11 : this.maxSpouseClaimMonths;
        this.minSpouseClaimMonths = 0;
        console.log('value', value);
        console.log('spouseMinClaimAge', spouseMinClaimAge);
        let userProvidedSurvivorAge = Number(this.adjustDesiredForm.value.spouseAgeYears || 0);
        // this.minSpouseClaimMonths = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 && userProvidedSurvivorAge == spouseMinClaimAge ? spouseMonthIndex == 1 ? (12 - spouseDOBMonth) + clientDOBMonth : spouseDOBMonth - clientDOBMonth: this.minSpouseClaimMonths;
        this.minSpouseClaimMonths = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 
          && userProvidedSurvivorAge == spouseMinClaimAge //&& userProvidedSurvivorAge == currAge
          ? spouseDOBMonth == 1 ? 0 : (13 - spouseDOBMonth)
          : this.minSpouseClaimMonths;
        // this.maxSpouseClaimMonths = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 ? 11: this.maxSpouseClaimMonths;
        console.log('this.minClientClaimMonths zss 01', this.minSpouseClaimMonths);
        console.log('this.maxSpouseClaimMonths zss 02', this.maxSpouseClaimMonths);
        // this.adjustDesiredForm.get("spouseAgeMonths").setValidators([Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
        // this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();
        
      if ((this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears || 0) > 0) {
        this.spouseMaxClaimAge = Math.min(69, this.data.clientProfile.Spouses[0].LifeExpectancy);
        this.maxSpouseClaimMonths = 11;
        this.minSpouseSurvivorSwitchClaimAge = spouseAge > 62 ? spouseAge : 62;
        this.minSpouseSurvivorSwitchClaimAge = Number(this.adjustDesiredForm.value.spouseAgeYears) > this.minSpouseSurvivorSwitchClaimAge ? (Number(this.adjustDesiredForm.value.spouseAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.spouseAgeYears) + 1 : Number(this.adjustDesiredForm.value.spouseAgeYears)):this.minSpouseSurvivorSwitchClaimAge;
        this.maxSpouseSurvivorSwitchClaimAge = 70;
        this.maxSpouseSurvivorSwitchClaimMonths = 11;
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxSpouseSurvivorSwitchClaimAge)]);
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').updateValueAndValidity();
        let spouseAgeMonths = Number(this.adjustDesiredForm.get('spouseAgeMonths').value || 0);
        this.minSpouseSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > Number(this.adjustDesiredForm.value.spouseAgeYears) ? 0: 
                                            (Number(this.adjustDesiredForm.value.clientAgeYears) > 0 ? (spouseAgeMonths < 11 ? Number(this.adjustDesiredForm.value.spouseAgeMonths) + 1:spouseAgeMonths): 0);
        console.log('this.minSurvivorSwitchClaimMonths', this.minSpouseSurvivorSwitchClaimMonths);
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimMonths), Validators.max(this.maxSpouseSurvivorSwitchClaimMonths)]);
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').updateValueAndValidity();
      }
      console.log('this.spouseMaxClaimAge', this.spouseMaxClaimAge);
      this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);      
      this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();

      this.adjustDesiredForm.get("spouseAgeMonths").setValidators([Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
      this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();
    } else {
      // Retirement benefit first and Survivir Benefits are second
      if(!this.isSpouseAgeReadOnly) {
        console.log('here i am 03 spouse');
        console.log('minClaimAge 066', this.minClaimAge);
        console.log('this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears', this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears);
        if (this.isShowSurvivorSection && !this.isSurvivorForClient) {
          let minimumSposueClaimAge = (this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge) ? this.minSpouseRetroFileClaimAge : Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) + 1 : Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears)): minSpouseClaimAge;
          console.log('minimumSposueClaimAge', minimumSposueClaimAge)
          this.spouseMinClaimAge = spouseMinClaimAge > minimumSposueClaimAge ? spouseMinClaimAge : minimumSposueClaimAge;
          console.log('this.minClaimAge', this.spouseMinClaimAge);
          console.log('do we have this.minRetroFileClaimMonths', this.minSpouseRetroFileClaimMonths);
          let userProvidedSurvivorAge = Number(this.adjustDesiredForm.value.spouseAgeYears || 0);
          this.minSpouseClaimMonths = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 && userProvidedSurvivorAge == spouseMinClaimAge ? spouseDOBMonth == 1 ? 0 : (13 - spouseDOBMonth): 0;
          console.log('this.minSpouseClaimMonths 00', this.minSpouseClaimMonths);
          this.minSpouseClaimMonths = (this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge && this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) ? this.minSpouseClaimMonths: (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths)): this.minSpouseClaimMonths);
          console.log('this.minSpouseClaimMonths 01', this.minSpouseClaimMonths);
          // this.minSpouseClaimMonths = spouseMinClaimAge > minimumSposueClaimAge ? spouseMonthIndex == 1 ? (12 - spouseDOBMonth) + clientDOBMonth : spouseDOBMonth - clientDOBMonth : this.minSpouseClaimMonths;
          this.minSpouseClaimMonths = spouseMinClaimAge > minimumSposueClaimAge && Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 && this.adjustDesiredForm.value.spouseAgeYears == spouseMinClaimAge ? spouseDOBMonth == 1 ? 0 : (13 - spouseDOBMonth) : this.minSpouseClaimMonths;
          console.log('this.minSpouseClaimMonths 02', this.minSpouseClaimMonths);
        } else {
          minSpouseClaimAge = spouseAge > 62 ? spouseAge: 62;
          console.log('minSpuseClaimAge', minSpouseClaimAge);
          this.spouseMinClaimAge =  (this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge && this.minSpouseRetroFileClaimAge) ? this.minSpouseRetroFileClaimAge : minSpouseClaimAge;
          let spouseAgeMonth = (!this.minSpouseRetroFileClaimAge) ? (spouseAge >= 62) ? (new Date().getMonth() + 1 > spouseDOBMonth ? new Date().getMonth() + 1 - spouseDOBMonth : new Date().getMonth() + 1 == spouseDOBMonth ? 0 : spouseDOBMonth - new Date().getMonth() + 1): 0 : 0;
          console.log('spouseAgeMonth check', spouseAgeMonth);
          this.minSpouseClaimMonths = (this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge && this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : spouseAgeMonth;
        }
        console.log('this.minSpouseRetroFileClaimAge 00001', this.minSpouseRetroFileClaimAge);

        this.spouseMaxClaimAge = Math.min(70, this.data.clientProfile.Spouses[0].LifeExpectancy);
        this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
        if (this.isShowSurvivorSection) {
          this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
        } else {
          this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
        }
        this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
        console.log('this.spouseMinClaimAge 00001', this.spouseMinClaimAge);

        
        console.log('this.minClientClaimMonths 002', this.minSpouseRetroFileClaimMonths);
        console.log('this.minSpouseClaimMonths 00001', this.minSpouseClaimMonths);
        this.minSpouseClaimMonths = value || this.adjustDesiredForm.value.spouseAgeYears ? this.minSpouseClaimMonths : 0;
        this.maxSpouseClaimMonths = value || this.adjustDesiredForm.value.spouseAgeYears ? this.maxSpouseClaimMonths : 0;
        this.adjustDesiredForm.get("spouseAgeMonths").setValidators((this.minSpouseClaimMonths > 0) ? [Validators.required, Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)] : [Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
        if (!this.adjustDesiredForm.value.spouseAgeYears && this.adjustDesiredForm.value.spouseAgeMonths == 0) {
          this.adjustDesiredForm.get("spouseAgeMonths").reset();
        }
        this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();
        this.adjustDesiredForm.get("spouseAgeMonths").markAsTouched();
        /* if(this.adjustDesiredForm.value.clientAgeYears == 70){
          this.adjustDesiredForm.get("spouseAgeMonths").markAsTouched();
        } */
        
        if (this.isShowSurvivorSection && !this.isSurvivorForClient) {
          this.maxSpouseSurvivorSwitchClaimAge = Number(this.adjustDesiredForm.value.spouseAgeYears)  == 70 ? 69: this.maxSpouseSurvivorSwitchClaimAge;
          this.maxSpouseSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.spouseAgeYears)  == 70 ? 11: this.maxSpouseSurvivorSwitchClaimMonths;
          this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.required, Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxSpouseSurvivorSwitchClaimAge)]);
          this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').updateValueAndValidity();
          this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimMonths), Validators.max(this.maxSpouseSurvivorSwitchClaimMonths)]);
          this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').updateValueAndValidity();
        }

      }

      if(!this.isSpouseAgeReadOnly){
        //if(this.adjustDesiredForm.value.spouseAgeYears){
        if(this.spouseMinClaimAge && this.adjustDesiredForm.value.spouseAgeYears){
          
          console.log('this.spouseMinClaimAge 0009', this.spouseMinClaimAge);
          console.log('this.spouseMinClaimAge 0009', minSpouseClaimAge);
          console.log('this.maxClaimAge 0009', this.maxClaimAge);

          this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
          this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
          
          console.log('this.minSpouseRetroFileClaimAge', this.minSpouseRetroFileClaimAge);
          console.log('this.minSpouseRetroFileClaimMonths', this.minSpouseRetroFileClaimMonths);
          console.log('this.adjustDesiredForm.value.spouseAgeYears', this.adjustDesiredForm.value.spouseAgeYears);
          this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;//Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
          this.minSpouseClaimMonths = (this.adjustDesiredForm.value.spouseAgeYears == this.minSpouseRetroFileClaimAge && this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : this.minSpouseClaimMonths;//(Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
          this.minSpouseClaimMonths = ((this.minSpouseClaimMonths > this.maxSpouseClaimMonths) && (Number(this.adjustDesiredForm.value.spouseAgeYears) == 70)) ? 0 : this.minSpouseClaimMonths;
          console.log('this.minSpouseClaimMonths 00009 - spouse', this.minSpouseClaimMonths);
          
          if(!this.minSpouseRetroFileClaimMonths){
            //this.minSpouseClaimMonths = this.adjustDesiredForm.value.spouseAgeYears > 62 && this.calculateAge(this.data.clientProfile.Spouses[0].dob) == this.adjustDesiredForm.value.spouseAgeYears ? (this.getDOBMonth(this.data.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) ? (new Date().getMonth() + 1) : ((new Date().getMonth() + 1) - this.getDOBMonth(this.data.clientProfile.Spouses[0].dob)) : this.minSpouseClaimMonths;
            var currAge = (this.dataFromModalAdjust.partnerDefaultAgeVal) ? parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[0]) : spouseAge;
            console.log('this.minSpouseClaimMonths 00009 - currAge', currAge);
            if(currAge >= 62) {
              console.log('this.dataFromModalAdjust.partnerDefaultAgeVal', this.dataFromModalAdjust.partnerDefaultAgeVal);
              var currMonth = (this.dataFromModalAdjust.partnerDefaultAgeVal) ? parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]) : this.minSpouseClaimMonths;
              console.log('this.minSpouseClaimMonths 00009 - currMonth', currMonth);
              // this.minSpouseClaimMonths = (currAge == Number(this.adjustDesiredForm.value.spouseAgeYears || 0)) ? (this.isSpouseRetroFiling) ? this.minSpouseRetroFileClaimMonths : currMonth : ((currAge < Number(this.adjustDesiredForm.value.spouseAgeYears || 0)) ? 0: this.minSpouseClaimMonths);
              this.minSpouseClaimMonths = (currAge == Number(this.adjustDesiredForm.value.spouseAgeYears || 0)) ? (this.isSpouseRetroFiling) ? this.minSpouseRetroFileClaimMonths : currMonth :this.minSpouseClaimMonths;
              
            } else {
              this.minSpouseClaimMonths = this.adjustDesiredForm.value.spouseAgeYears > 62 && this.calculateAge(this.data.clientProfile.Spouses[0].dob) == this.adjustDesiredForm.value.spouseAgeYears ? (this.getDOBMonth(this.data.clientProfile.Spouses[0].dob) > (new Date().getMonth() + 1)) ? (new Date().getMonth() + 1) : ((new Date().getMonth() + 1) - this.getDOBMonth(this.data.clientProfile.Spouses[0].dob)) : this.minSpouseClaimMonths;
            }

            console.log('this.minSpouseClaimMonths 00009 - spouse', this.minSpouseClaimMonths);
          }

          this.adjustDesiredForm.get("spouseAgeMonths").setValidators((this.minSpouseClaimMonths > 0) 
            ? [Validators.required, Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)] 
            : [Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
          this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();

          //if(this.adjustDesiredForm.value.spouseAgeYears == 70){
            this.adjustDesiredForm.get("spouseAgeMonths").markAsTouched();
          //}
        }
      }
      
      // if (this.adjustDesiredForm.value.spouseAgeYears > this.globalService.calculateAgeV2(this.data.clientProfile.Spouses[0].dob) || this.adjustDesiredForm.value.spouseAgeYears > this.data.clientProfile.Spouses[0].LifeExpectancy ) {
      //   this.adjustDesiredForm.get("spouseAgeYears").setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
      //   this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
      //   this.adjustDesiredForm.get("spouseAgeMonths").setValidators([Validators.required, Validators.min(0), Validators.max(0)]);
      //   this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();
      // }

    }

  }

  onRetirementBenefit(value, type, isDCA = false){
    console.log('in retirement benefit onclick1');
    if(!this.isClientFilingRestricted && !this.isSpouseFilingRestricted){// && this.data.clientProfile.Spouses[0].maritalStatus == 'Widowed'){
      console.log('this.isSurvivorForClient', this.isSurvivorForClient);
      console.log('this.isSurvivorBenefitFirstClaim', this.isSurvivorBenefitFirstClaim);

      if (this.isSurvivorBenefitFirstClaim && this.isSurvivorForClient) {
        console.log('this.isSurvivorForClient', this.isSurvivorForClient);
        // Survivor Benefits are first claim and Retirement Benefits are second claim
        //var currAge = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
        //var currMonth = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
        let clientAge = this.calculateAge(this.data.client.DOB);
        this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
        let clientAgeMonths = Number(this.adjustDesiredForm.get('clientAgeMonths').value || 0);
        let clientAgeYears = Number(this.adjustDesiredForm.get('clientAgeYears').value || 0);
        this.minSurvivorSwitchClaimAge = clientAgeYears > this.minSurvivorSwitchClaimAge ? (clientAgeMonths == 11 ? clientAgeYears + 1 : clientAgeYears):this.minSurvivorSwitchClaimAge;
        this.maxSurvivorSwitchClaimAge = Math.min(70,this.data.clientProfile.LifeExpectancy);
        this.maxSurvivorSwitchClaimMonths = 0;
        //this.maxSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.clientAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.clientAgeYears || 0) != 0  ? 11 : 0;
        //this.minClientClaimMonths = clientAge >= 62 && clientAge == Number(this.adjustDesiredForm.value.clientAgeYears || 0) ? currMonth : 0;

        let survivorSwitchAgeYears = Number(this.adjustDesiredForm.get('survivorSwitchAgeYears').value || 0);
        console.log('survivorSwitchAgeYears test', survivorSwitchAgeYears);

        console.log('clientAgeMonths', clientAgeMonths);
        this.minSurvivorSwitchClaimMonths = survivorSwitchAgeYears == 70 || survivorSwitchAgeYears > clientAgeYears ? 0: 
                                            (clientAgeYears > 0 ? (clientAgeMonths < 11 ? clientAgeMonths + 1:clientAgeMonths): 0);
        this.maxSurvivorSwitchClaimMonths = survivorSwitchAgeYears == 70 ? 0 : 11;
        console.log('this.minSurvivorSwitchClaimMonths', this.minSurvivorSwitchClaimMonths);        
        // this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
        // this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
        // this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
        // this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();


        let minClaimAge = clientAge > 60 ? clientAge : 60;
        let clientMinClaimAge = this.getClientMinClaimAge();
        let clientDOBMonth = new Date (this.data.client.DOB).getMonth() + 1;
        this.minClaimAge = clientMinClaimAge > minClaimAge && clientMinClaimAge < 70 ? clientMinClaimAge : this.minClaimAge;
        this.minClientClaimMonths = this.adjustDesiredForm.value.clientAgeYears == this.minClaimAge && this.minClaimAge == clientMinClaimAge ? clientDOBMonth == 1 ? 0 : (13 - clientDOBMonth): this.minClientClaimMonths;
        this.maxClaimAge = Math.min(Number(this.adjustDesiredForm.value.clientAgeYears)  == 70 ? 69: this.maxClaimAge, this.data.clientProfile.LifeExpectancy);
        this.maxClientClaimMonths = Number(this.adjustDesiredForm.value.clientAgeYears)  == 70 ? 69: this.maxClientClaimMonths;
        if (this.adjustDesiredForm.value.clientAgeYears) {
          this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
          this.adjustDesiredForm.get('clientAgeMonths').setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
          this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();
          
        } else {
          this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
        }
                
        this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators((!this.isSurvivorBenefitFirstClaim) 
          ? [Validators.required, Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)] 
          : [Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
        this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
        this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators((this.minSurvivorSwitchClaimMonths && survivorSwitchAgeYears > 0) // || !this.isSurvivorBenefitFirstClaim) 
          ? [Validators.required, Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)] 
          : [Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
        this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
      } 
      // else if (this.isSpouseSurvivorBenefitFirstClaim && !this.isSurvivorForClient) {
      //   // Survivor Benefits are first claim and Retirement Benefits are second claim
      //   let clientAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
      //   this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
      //   let clientAgeMonths = Number(this.adjustDesiredForm.get('spouseAgeMonths').value || 0);
      //   let clientAgeYears = Number(this.adjustDesiredForm.get('spouseAgeYears').value || 0);
      //   this.minSurvivorSwitchClaimAge = clientAgeYears > this.minSurvivorSwitchClaimAge ? (clientAgeMonths == 11 ? clientAgeYears + 1 : clientAgeYears):this.minSurvivorSwitchClaimAge;
      //   this.maxSurvivorSwitchClaimAge = 70;
      //   this.maxSurvivorSwitchClaimMonths = 0;
      //   // this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
      //   // this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();

      //   let survivorSwitchAgeYears = Number(this.adjustDesiredForm.get('survivorSwitchAgeYears').value || 0);

      //   console.log('clientAgeMonths 22', clientAgeMonths);
      //   this.minSurvivorSwitchClaimMonths = survivorSwitchAgeYears == 70 || survivorSwitchAgeYears > clientAgeYears ? 0: 
      //                                       (clientAgeYears > 0 ? (clientAgeMonths < 11 ? clientAgeMonths + 1:clientAgeMonths): 0);
      //   this.maxSurvivorSwitchClaimMonths = survivorSwitchAgeYears == 70 ? 0 : 11;
      //   console.log('this.minSurvivorSwitchClaimMonths 22', this.minSurvivorSwitchClaimMonths)
      //   // this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
      //   // this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
        
      // } 
      else {
        console.log('in the ELSE');

        var currAge = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
        var currMonth = parseInt(this.dataFromModalAdjust.clientDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
        console.log('earliest age month', currMonth);
          // Retirement benefit first and Survivir Benefits are second
        let clientAge = this.calculateAge(this.data.client.DOB);
        this.minSurvivorSwitchClaimAge = clientAge > 62 ? clientAge : 62;
        console.log('minSurvivorSwitchClaimAge', this.minSurvivorSwitchClaimAge);
        this.maxSurvivorSwitchClaimAge = Math.min(70,this.data.clientProfile.Spouses[0].LifeExpectancy);
        this.maxSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) != 0  ? 11 : 0;
        this.minSurvivorSwitchClaimMonths = clientAge >= 62 && clientAge == Number(this.adjustDesiredForm.value.survivorSwitchAgeYears || 0) ? currMonth : 0;
        // this.maxSurvivorSwitchClaimMonths = 11;
        // this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
        // this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
        // this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(0), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
        // this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();

        if (this.adjustDesiredForm.value.clientAgeYears) {
          console.log('here i am 03');
          // let clientAge = this.calculateAge(this.data.client.DOB);
          // let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
          // let clientRemainingYear = this.data.clientProfile.LifeExpectancy - clientAge;
          let clientDOBMonth = new Date (this.data.client.DOB).getMonth() + 1;
          // let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
          // let spouseMonthIndex = spouseDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
          // let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - (spouseAge + spouseMonthIndex);
          // let clientMinClaimAge = clientRemainingYear > spouseRemainingYear && this.isShowSurvivorSection ? clientAge + spouseRemainingYear  : 0;
          let clientMinClaimAge = this.getClientMinClaimAge();
          let minClaimAge = clientAge > 60 ? clientAge : 60;
          this.minClaimAge = Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 
            ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) == 11 
              ? Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) + 1 
              : Number(this.adjustDesiredForm.value.survivorSwitchAgeYears))
            : minClaimAge;
          console.log('this.minClaimAge', this.minClaimAge);
          console.log('clientMinClaimAge', clientMinClaimAge);
          //ZSS HPV-2296 this line was causing issues
          //this.minClaimAge = clientMinClaimAge > this.minClaimAge ? clientMinClaimAge : this.minClaimAge;
          console.log('this.minClaimAge', this.minClaimAge);
          this.maxClaimAge = Math.min(70, this.data.clientProfile.Spouses[0].LifeExpectancy);
          this.maxClientClaimMonths = (Number(this.adjustDesiredForm.value.clientAgeYears) == 70) ? 0 : 11;
          // console.log('this.adjustDesiredForm.value.clientAgeYears', this.adjustDesiredForm.value.clientAgeYears);
          // console.log('maxClientYears', this.maxClaimAge);
          // console.log('this.maxClientClaimMonths', this.maxClientClaimMonths);
          this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();
          this.minClientClaimMonths =  (this.minRetroFileClaimMonths) ? this.minRetroFileClaimMonths : Number(this.adjustDesiredForm.value.clientAgeYears) == 70 || Number(this.adjustDesiredForm.value.clientAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);

          this.minClientClaimMonths = clientMinClaimAge > this.minClaimAge && clientMinClaimAge < 70 && this.adjustDesiredForm.value.clientAgeYears == this.minClaimAge && this.minClaimAge == clientMinClaimAge? clientDOBMonth == 1 ? 0: (13 - clientDOBMonth): this.minClientClaimMonths;
          console.log('this.minClientClaimMonths test01', this.minClientClaimMonths);
          this.adjustDesiredForm.get("clientAgeMonths").setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
          this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();

          this.maxSurvivorSwitchClaimAge = 69;
          this.minSurvivorSwitchClaimMonths = 0;
          this.maxSurvivorSwitchClaimMonths = 11;
        }
        // console.log('here i am 01')
        // this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
        // this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
        // this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators([Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
        // this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity();
        // console.log('here i am 02')

        if(this.adjustDesiredForm.value.spouseAgeYears && !this.isSpouseAgeReadOnly){
          console.log('made it to spouseAgeYears in Ret');
          //this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          //this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required]);
          //this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(this.spouseMinClaimAge), Validators.max(this.maxClaimAge)]);
          //this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
          //this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
          this.minSpouseClaimMonths = 0;//Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
          this.maxSpouseClaimMonths = (this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : (Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
          console.log('this.minSpouseClaimMonths', this.minSpouseClaimMonths);
          this.adjustDesiredForm.get("spouseAgeMonths").setValidators([Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
          this.adjustDesiredForm.get("spouseAgeMonths").updateValueAndValidity();
        }

        if (!this.isSurvivorBenefitFirstClaim && this.isSurvivorForClient) {
          //need to clear the 'required' flag on page load IF Retirement is on top
          console.log('ret on top - client min age', this.minClaimAge);
          //this.adjustDesiredForm.get('survivorSwitchAgeYears').reset();
          //this.adjustDesiredForm.get('survivorSwitchAgeYears').clearValidators();

          //ZSS HPV-2273 fix
          //was: this.minClaimAge = (this.minRetroFileClaimAge) ? this.minRetroFileClaimAge : this.minClaimAge;
          this.minClaimAge = (this.minRetroFileClaimAge) ? this.minRetroFileClaimAge : (this.minSurvivorSwitchClaimAge < this.minClaimAge) ? this.minSurvivorSwitchClaimAge : this.minClaimAge;
          this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          this.adjustDesiredForm.get("survivorSwitchAgeYears").updateValueAndValidity();

          //this.adjustDesiredForm.get('survivorSwitchAgeMonths').reset();
          //this.adjustDesiredForm.get('survivorSwitchAgeMonths').clearValidators();
          this.minSurvivorSwitchClaimMonths = (this.minRetroFileClaimMonths && this.minRetroFileClaimAge == this.adjustDesiredForm.value.survivorSwitchAgeYears) 
            ? this.minRetroFileClaimMonths 
            : (this.minSurvivorSwitchClaimMonths < this.minRetroFileClaimMonths) 
            ? 0
            //? ((this.adjustDesiredForm.value.survivorSwitchAgeYears == this.minClaimAge) ? currMonth : 0)
            :  this.adjustDesiredForm.value.survivorSwitchAgeYears == 70 ? 0: this.minSurvivorSwitchClaimMonths;
          this.maxSurvivorSwitchClaimMonths = this.adjustDesiredForm.value.survivorSwitchAgeYears == 70 ? 0: this.maxSurvivorSwitchClaimMonths;
          this.adjustDesiredForm.get("survivorSwitchAgeMonths").setValidators((this.minSurvivorSwitchClaimMonths) 
            ? [Validators.required, Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]
            : [Validators.min(this.minSurvivorSwitchClaimMonths), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
          this.adjustDesiredForm.get("survivorSwitchAgeMonths").updateValueAndValidity();
          this.adjustDesiredForm.get("survivorSwitchAgeMonths").markAsTouched();

          this.adjustDesiredForm.get('clientAgeYears').reset();
          this.adjustDesiredForm.get('clientAgeYears').clearValidators();
          this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
          this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();

          this.adjustDesiredForm.get('clientAgeMonths').reset();
          this.adjustDesiredForm.get('clientAgeMonths').clearValidators();
          this.adjustDesiredForm.get("clientAgeMonths").setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
          this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();
        }

      }

      /* this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators((!this.isSurvivorBenefitFirstClaim) 
        ? [Validators.required, Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)] 
        : [Validators.min(this.minSurvivorSwitchClaimAge), Validators.max(this.maxSurvivorSwitchClaimAge)]);
      this.adjustDesiredForm.get('survivorSwitchAgeYears').updateValueAndValidity();
      this.adjustDesiredForm.get('survivorSwitchAgeMonths').setValidators((this.minSurvivorSwitchClaimMonths) // || !this.isSurvivorBenefitFirstClaim) 
        ? [Validators.required, Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)] 
        : [Validators.min(((!this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0 : this.minSurvivorSwitchClaimMonths)), Validators.max(this.maxSurvivorSwitchClaimMonths)]);
      this.adjustDesiredForm.get('survivorSwitchAgeMonths').updateValueAndValidity(); */
            
    }

    //File Restricted stuff
    if(this.isClientFilingRestricted){
      console.log('is filing restricted');
      var year = (type == 'year' && isDCA) ? value : this.adjustDesiredForm.value.clientAgeYears;
      var month = (type == 'month' && isDCA) ? value : this.adjustDesiredForm.value.clientAgeMonths;
      var fYear = (type == 'year' && !isDCA) ? value : this.adjustDesiredForm.value.fileRestrictedAgeYears;
      var fMonth = (type == 'month' && !isDCA) ? value : this.adjustDesiredForm.value.fileRestrictedAgeMonths;

      if(fYear == year && year == 69){
        //this.adjustDesiredForm.get('clientAgeMonths').reset();
        this.adjustDesiredForm.get('clientAgeMonths').setValidators([Validators.required, Validators.min((fMonth) ? fMonth : this.minFileRestrictedMonths), Validators.max(11)]); 
        if(month < fMonth){
          this.adjustDesiredForm.get('clientAgeMonths').reset();
        }
        
      } else {
        //this.adjustDesiredForm.get('clientAgeMonths').reset();
        this.adjustDesiredForm.get('clientAgeMonths').clearValidators();
      }

      this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();

      //if FR and RF
      /* if(this.minRetroFileClaimMonths){
        console.log('client is FR and RF');
        this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(this.minClaimAge), Validators.max(this.maxClaimAge)]);
        this.adjustDesiredForm.get("clientAgeYears").updateValueAndValidity();
        this.minClientClaimMonths =  (this.minRetroFileClaimMonths) ? this.minRetroFileClaimMonths : Number(this.adjustDesiredForm.value.clientAgeYears) == 70 || Number(this.adjustDesiredForm.value.clientAgeYears) > Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.survivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.survivorSwitchAgeMonths)): 0);
        console.log('this.minClientClaimMonths', this.minClientClaimMonths);
        this.adjustDesiredForm.get("clientAgeMonths").setValidators([Validators.min(this.minClientClaimMonths), Validators.max(this.maxClientClaimMonths)]);
        this.adjustDesiredForm.get("clientAgeMonths").updateValueAndValidity();
      } */
      console.log('form validation check', this.adjustDesiredForm);
    }

    if(this.isSpouseFilingRestricted){
      console.log('spouse is filing restricted');
      var year = (type == 'year' && isDCA) ? value : this.adjustDesiredForm.value.spouseAgeYears;
      var month = (type == 'month' && isDCA) ? value : this.adjustDesiredForm.value.spouseAgeMonths;
      var fYear = (type == 'year' && !isDCA) ? value : this.adjustDesiredForm.value.spouseFileRestrictedAgeYears;
      var fMonth = (type == 'month' && !isDCA) ? value : this.adjustDesiredForm.value.spouseFileRestrictedAgeMonths;

      if(fYear == year && year == 69){
        this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.required, Validators.min((fMonth) ? fMonth : this.minSpouseFileRestrictedClaimMonths), Validators.max(11)]);
        if(month < fMonth){
          this.adjustDesiredForm.get('spouseAgeMonths').reset();
        }
      } else {
        this.adjustDesiredForm.get('spouseAgeMonths').reset();
        this.adjustDesiredForm.get('spouseAgeMonths').clearValidators();        
      }

      this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
    }
  }

  onSpouseRetirementBenefit(value, type, isDCA = false){
    console.log('in retirement benefit onclick');
    let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
    if(!this.isClientFilingRestricted && !this.isSpouseFilingRestricted){
      if (this.isSpouseSurvivorBenefitFirstClaim && !this.isSurvivorForClient) {
        // Survivor Benefits are first claim and Retirement Benefits are second claim
       console.log('!this.isSurvivorForClient')
        this.minSpouseSurvivorSwitchClaimAge = spouseAge > 62 ? spouseAge : 62;
        let spouseAgeMonths = Number(this.adjustDesiredForm.get('spouseAgeMonths').value || 0);
        let spouseAgeYears = Number(this.adjustDesiredForm.get('spouseAgeYears').value || 0);
        this.minSpouseSurvivorSwitchClaimAge = spouseAgeYears > this.minSpouseSurvivorSwitchClaimAge ? (spouseAgeMonths == 11 ? spouseAgeYears + 1 : spouseAgeYears):this.minSpouseSurvivorSwitchClaimAge;
        this.maxSpouseSurvivorSwitchClaimAge = 70;
        this.maxSpouseSurvivorSwitchClaimMonths = 0;
        console.log('this.minSpouseSurvivorSwitchClaimAge', this.minSpouseSurvivorSwitchClaimAge);
        console.log('this.maxSpouseSurvivorSwitchClaimAge', this.maxSpouseSurvivorSwitchClaimAge);
        let spouseSurvivorSwitchAgeYears = Number(this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').value || 0);
        console.log('clientAgeMonths 22', spouseAgeMonths);
        this.minSpouseSurvivorSwitchClaimMonths = spouseSurvivorSwitchAgeYears == 70 || spouseSurvivorSwitchAgeYears > spouseAgeYears ? 0: 
                                            (spouseAgeYears > 0 ? (spouseAgeMonths < 11 ? spouseAgeMonths + 1:spouseAgeMonths): 0);
        this.maxSpouseSurvivorSwitchClaimMonths = spouseSurvivorSwitchAgeYears == 70 ? 0 : 11;
        console.log('this.minSurvivorSwitchClaimMonths', this.minSpouseSurvivorSwitchClaimMonths);
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxSpouseSurvivorSwitchClaimAge)]);
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').updateValueAndValidity();
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimMonths), Validators.max(this.maxSpouseSurvivorSwitchClaimMonths)]);
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').updateValueAndValidity();
        if(!this.isSpouseAgeReadOnly){
          let minSpouseClaimAge = spouseAge > 60 ? spouseAge : 60;
          let spouseMinClaimAge = this.getSpouseMinClaimAge();
          let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
          this.spouseMinClaimAge = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 ? spouseMinClaimAge : this.spouseMinClaimAge;
          this.minSpouseClaimMonths = this.adjustDesiredForm.value.spouseAgeYears == this.spouseMinClaimAge && this.spouseMinClaimAge == spouseMinClaimAge ? spouseDOBMonth == 1 ? 0 : (13 - spouseDOBMonth): this.minSpouseClaimMonths;
          this.spouseMaxClaimAge = Math.min(Number(this.adjustDesiredForm.value.spouseAgeYears)  == 70 ? 69: this.spouseMaxClaimAge, this.data.clientProfile.Spouses[0].LifeExpectancy);;
          this.maxSpouseClaimMonths = Number(this.adjustDesiredForm.value.spouseAgeYears)  == 70 ? 69: this.maxSpouseClaimMonths;
          this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
          this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();
          this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
          this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
        }
        
      } else {
          // Retirement benefit first and Survivir Benefits are second
        // var currAge = parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[0]);
        var currSpouseMonth = parseInt(this.dataFromModalAdjust.partnerDefaultAgeVal.replaceAll(' ', '').split('y')[1].split('m')[0]);
        console.log('currMonth', currSpouseMonth);
        this.minSpouseSurvivorSwitchClaimAge= spouseAge > 62 ? spouseAge : 62;
        this.maxSpouseSurvivorSwitchClaimAge = 70;
        this.maxSpouseSurvivorSwitchClaimMonths = Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears || 0) < 70 && Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears || 0) != 0  ? 11 : 0;
        this.minSpouseSurvivorSwitchClaimMonths = spouseAge >= 62 ? currSpouseMonth : 0;
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxSpouseSurvivorSwitchClaimAge)]);
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').updateValueAndValidity();
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').setValidators([Validators.min(0), Validators.max(this.maxSpouseSurvivorSwitchClaimMonths)]);
        // this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').updateValueAndValidity();

        if (this.adjustDesiredForm.value.spouseAgeYears) {
          console.log('here i am 03');
          // let clientAge = this.calculateAge(this.data.client.DOB);
          // let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
          // let clientRemainingYear = this.data.clientProfile.LifeExpectancy - clientAge;
          // let clientDOBMonth = new Date (this.data.client.DOB).getMonth() + 1;
          let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
          // let spouseMonthIndex = spouseDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
          // let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - (spouseAge + spouseMonthIndex);
          // let spouseMinClaimAge = spouseRemainingYear > clientRemainingYear && this.isShowSurvivorSection ? spouseAge + clientRemainingYear  : 0;
          let spouseMinClaimAge = this.getSpouseMinClaimAge();
          let minSpouseClaimAge = spouseAge > 60 ? spouseAge : 60;
          this.spouseMinClaimAge = Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) == 11 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) + 1:Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears)): minSpouseClaimAge;
          this.spouseMinClaimAge = spouseMinClaimAge > minSpouseClaimAge && spouseMinClaimAge < 70 ? spouseMinClaimAge : this.spouseMinClaimAge;
          console.log('this.minClaimAge', this.spouseMinClaimAge);
          this.spouseMaxClaimAge = Math.min(70, this.data.clientProfile.Spouses[0].LifeExpectancy);
          this.maxSpouseClaimMonths = (Number(this.adjustDesiredForm.value.spouseAgeYears) == 70) ? 0 : 11;
          this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.min(this.spouseMinClaimAge), Validators.max(this.spouseMaxClaimAge)]);
          this.adjustDesiredForm.get("spouseAgeYears").updateValueAndValidity();
          this.minSpouseClaimMonths =  (this.minSpouseRetroFileClaimMonths) ? this.minSpouseRetroFileClaimMonths : Number(this.adjustDesiredForm.value.spouseAgeYears) == 70 || Number(this.adjustDesiredForm.value.spouseAgeYears) > Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) ? 0: (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeYears) > 0 ? (Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) < 11 ? Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths) + 1:Number(this.adjustDesiredForm.value.spouseSurvivorSwitchAgeMonths)): 0);
          this.minSpouseClaimMonths = spouseMinClaimAge > this.minSpouseClaimMonths && spouseMinClaimAge < 70 && Number(this.adjustDesiredForm.value.spouseAgeYears) == this.spouseMinClaimAge ? spouseDOBMonth == 1 ? 0 : (13 - spouseDOBMonth): this.minSpouseClaimMonths;
          //if(!this.minSpouseRetroFileClaimMonths){
            //this.minSpouseClaimMonths = spouseAge > 62 && this.calculateAge(this.data.clientProfile.Spouses[0].dob) == spouseAge ? ((new Date().getMonth() + 1) - this.getDOBMonth(this.data.clientProfile.Spouses[0].dob)) : this.minSpouseClaimMonths;
          //}

          console.log('this.minClientClaimMonths test01', this.minClientClaimMonths);
          console.log('this.minSpouseClaimMonths', this.minSpouseClaimMonths);
          console.log('this.maxSpouseClaimMonths', this.maxSpouseClaimMonths);
          this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.min(this.minSpouseClaimMonths), Validators.max(this.maxSpouseClaimMonths)]);
          // this.adjustDesiredForm.get('spousetAgeMonths').updateValueAndValidity(); // enable this one is causing problem but without enabling also working

          // this.adjustDesiredForm.get('spouseAgeMonths').reset();
          // this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();

          this.maxSpouseSurvivorSwitchClaimAge = 69;
          this.minSpouseSurvivorSwitchClaimMonths = 0;
          this.maxSpouseSurvivorSwitchClaimMonths = 11;

        }
      }
      console.log('here i am 01');
      if(this.isSpouseSurvivorBenefitFirstClaim){
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxSpouseSurvivorSwitchClaimAge)]);
      } else {
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.required, Validators.min(this.minSpouseSurvivorSwitchClaimAge), Validators.max(this.maxSpouseSurvivorSwitchClaimAge)]);
      }
      this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').updateValueAndValidity();
      this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').setValidators([Validators.min(this.minSpouseSurvivorSwitchClaimMonths), Validators.max(this.maxSpouseSurvivorSwitchClaimMonths)]);
      this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').updateValueAndValidity();
      console.log('here i am 02')
    }

    if(this.isSpouseFilingRestricted){
      var year = (type == 'year' && isDCA) ? value : this.adjustDesiredForm.value.spouseAgeYears;
      var month = (type == 'month' && isDCA) ? value : this.adjustDesiredForm.value.spouseAgeMonths;
      var fYear = (type == 'year' && !isDCA) ? value : this.adjustDesiredForm.value.spouseFileRestrictedAgeYears;
      var fMonth = (type == 'month' && !isDCA) ? value : this.adjustDesiredForm.value.spouseFileRestrictedAgeMonths;

      if(fYear == year && year == 69){
        this.adjustDesiredForm.get('spouseAgeMonths').setValidators([Validators.required, Validators.min((fMonth) ? fMonth : this.minSpouseFileRestrictedClaimMonths), Validators.max(11)]);
        if(month < fMonth){
          this.adjustDesiredForm.get('spouseAgeMonths').reset();
        }
      } else {
        this.adjustDesiredForm.get('spouseAgeMonths').reset();
        this.adjustDesiredForm.get('spouseAgeMonths').clearValidators();        
      }

      this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
    }
  }

   getClientMinClaimAge() {
    let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
    let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
    let clientAge = this.calculateAge(this.data.client.DOB);
    let clientDOBMonth =  new Date(this.data.client.DOB).getMonth() + 1;
    let currentMonth = new Date().getMonth() + 1;
    let clientAgeIndex = clientDOBMonth <= currentMonth ? 0 : 1;
    clientAge = clientAge + clientAgeIndex;
    let spouseAgeIndex = spouseDOBMonth <= currentMonth ? 0 : 1;
    spouseAge = spouseAge + spouseAgeIndex;
    let clientRemainingYear = this.data.clientProfile.LifeExpectancy - clientAge;
    //let spouseMonthIndex = spouseDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
    //let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - (spouseAge + spouseMonthIndex);
    console.log('getClientMinClaimAge clientAge', clientAge);
    console.log('getClientMinClaimAge clientRemainingYear', clientRemainingYear);
    let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - (spouseAge);
    // if(spouseDOBMonth > new Date().getMonth() + 1){
    //   spouseRemainingYear += 1;
    // }
    let spouseRemainingYearIndex = clientDOBMonth == 1 ? 1:0;
    spouseRemainingYear += spouseRemainingYearIndex;
    console.log('getClientMinClaimAge spouseRemainingYear', spouseRemainingYear);
    let clientMinClaimAge = clientRemainingYear > spouseRemainingYear && this.isShowSurvivorSection ? clientAge + spouseRemainingYear  : 0;
    return clientMinClaimAge; 
  }

  // getSpouseMinClaimAge() {
  //   let clientAge = this.calculateAge(this.data.client.DOB);
  //   let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
  //   let clientDOBMonth =  new Date(this.data.client.DOB).getMonth() + 1;
  //   let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
  //   let currentMonth = new Date().getMonth() + 1;
  //   let spouseAgeIndex = spouseDOBMonth <= currentMonth ? 0 : 1;
  //   spouseAge = spouseAge + spouseAgeIndex;
  //   let clientRemainingYear = this.data.clientProfile.LifeExpectancy - (clientAge);    
  //   let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - spouseAge;
  //   console.log('clientRemainingYear 01', clientRemainingYear);
  //   if(clientDOBMonth > new Date().getMonth() + 1){
  //     // clientRemainingYear += 1;
  //   } else {
  //     let spouseMonth =  new Date(this.data.clientProfile.Spouses[0].dob);
  //     let spouseAgeIndex = spouseMonth.getMonth() + 1 == 1 ? 1:0;
  //     console.log('spouseAgeIndex', spouseAgeIndex)
  //     if(spouseRemainingYear > clientRemainingYear && spouseAgeIndex == 1) {
  //       clientRemainingYear += 1;
  //     }
  //   }
  //   console.log('clientRemainingYear 92', clientRemainingYear);
  //   console.log('spouseRemainingYear', spouseRemainingYear);
  //   let spouseMinClaimAge = spouseRemainingYear > clientRemainingYear && this.isShowSurvivorSection ? spouseAge + clientRemainingYear  : 0;
  //   console.log('spouseMinClaimAge 22', spouseMinClaimAge);
  //   return spouseMinClaimAge;
  // }

  getSpouseMinClaimAge() {
    let clientAge = this.calculateAge(this.data.client.DOB);
    let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
    let clientDOBMonth =  new Date(this.data.client.DOB).getMonth() + 1;
    let spouseDOBMonth =  new Date(this.data.clientProfile.Spouses[0].dob).getMonth() + 1;
    let currentMonth = new Date().getMonth() + 1;
    let spouseAgeIndex = spouseDOBMonth <= currentMonth ? 0 : 1;
    spouseAge = spouseAge + spouseAgeIndex;
    let clientAgeIndex = clientDOBMonth <= currentMonth ? 0 : 1;
    clientAge = clientAge + clientAgeIndex;
    let clientRemainingYear = this.data.clientProfile.LifeExpectancy - (clientAge);    
    let spouseRemainingYear = this.data.clientProfile.Spouses[0].LifeExpectancy - spouseAge;
    console.log('clientRemainingYear 01', clientRemainingYear);
    // if(clientDOBMonth > new Date().getMonth() + 1){
    //   // clientRemainingYear += 1;
    // } else {
    //   let spouseMonth =  new Date(this.data.clientProfile.Spouses[0].dob);
    //   let spouseAgeIndex = spouseMonth.getMonth() + 1 == 1 ? 1:0;
    //   console.log('spouseAgeIndex', spouseAgeIndex)
    //   if(spouseRemainingYear > clientRemainingYear && spouseAgeIndex == 1) {
    //     clientRemainingYear += 1;
    //   }
    // }
    let clientRemainingYearIndex = spouseDOBMonth == 1 ? 1:0;
    clientRemainingYear += clientRemainingYearIndex;
    console.log('clientRemainingYear 92', clientRemainingYear);
    console.log('spouseRemainingYear', spouseRemainingYear);
    let spouseMinClaimAge = spouseRemainingYear > clientRemainingYear && this.isShowSurvivorSection ? spouseAge + clientRemainingYear  : 0;
    console.log('spouseMinClaimAge 22', spouseMinClaimAge);
    return spouseMinClaimAge;
  }


  convertToYear(currentAge, retirementAge){
    var date = new Date().getFullYear();
    return (retirementAge - this.convertDOBToAge(currentAge)) + date;
  }

  convertDOBToAge(dob){
    dob = new Date(dob);
    var ageDifMs = Date.now() - dob;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  getDOBMonth(birthday){
    return new Date(birthday).getMonth() + 1;
  }

  getBirthdayFullYear(dob: Date){
    //const birthDate = new Date(dob);
    const startYear = new Date().getFullYear();

    var _monthOffset = 0;
    // If the person's DOB falls on the first day of the month, Soc.Sec. pretends they are an extra month older (as if born in the PREVIOUS month)
    if (dob.getDate() == 1)
    {
      _monthOffset = 1;
    }
    //return _monthOffset;
    // console.log('month day', dob.getDate());
    // console.log('month day offset', _monthOffset);


    var _yearOffset = 0;
    // If the person's DOB falls on New Year's Day, Soc.Sec. references factors and age thresholds according to the PREVIOUS year
    if ((dob.getMonth() == 0) && (_monthOffset == 1))
    {
      //(dbarksdale3) Updated behavior of this value
      //_yearOffset = -1;
      _yearOffset = 1;
    }
    //return _yearOffset;
    // console.log('month', dob.getMonth());
    // console.log('year offset', _yearOffset);


    return (startYear - this.getCurrentAgeByDOB(dob) - _yearOffset);
  }

  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('getCurrentAgeByDOB', ((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  getFRAv2(bday){
    // const startYear = new Date().getFullYear();
    const birthDate = new Date(bday);
    //var yearOfBirth = birthDate.getFullYear();
    var yearOfBirth = this.getBirthdayFullYear(birthDate);

    // var yearOfBirth = startYear - birthYear;
    // console.log('yearOfBirth',yearOfBirth);
    var fraMonths = 0;
    if(yearOfBirth <= 1954){
      if (yearOfBirth <= 1937) {
        fraMonths = 780;
      } else {
        if (yearOfBirth <=1942) {
          switch (yearOfBirth)
          {
            case 1938:
              fraMonths = 780+2;
              break;
            case 1939:
              fraMonths = 780 + 4;
              break;
            case 1940:
              fraMonths = 780 + 6;
              break;
            case 1941:
              fraMonths = 780 + 8;
              break;
            case 1942:
              fraMonths = 780 + 10;
              break;

          }
        } else {
          fraMonths = 792;
        }

      }
    } else if (yearOfBirth <=1961 && this.data.clientProfile.Spouses[0].maritalStatus === 'Widowed') {
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 0;
          break;
        case 1956:
          fraMonths = 792 + 0;
          break;
        case 1957:
          fraMonths = 792 + 2;
          break;
        case 1958:
          fraMonths = 792 + 4;
          break;
        case 1959:
          fraMonths = 792 + 6;
          break;
        case 1960:
          fraMonths = 792 + 8;
          break;
        case 1961:
          fraMonths = 792 + 10;
          break;
      }
    } else if(yearOfBirth <= 1959){
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 2;
          break;
        case 1956:
          fraMonths = 792 + 4;
          break;
        case 1957:
          fraMonths = 792 + 6;
          break;
        case 1958:
          fraMonths = 792 + 8;
          break;
        case 1959:
          fraMonths = 792 + 10;
          break;
      }
    } else {
      fraMonths = 804;
    }

    // console.log('fraMonths', fraMonths);
    var fra = fraMonths / 12;
    // console.log('fra', fra);
    // console.log('framonthtest', )

    let FRA = {
      age: 0,
      month: 0,
    }
    FRA.age = Math.floor(fra);
    //console.log('log FRA', fra%12)
    //this.getBirthdayMonth(bday)
    FRA.month = fraMonths % 12;

    // console.log('returned FRA', FRA);
    return FRA
  }

  swapClaimWasToggled: boolean = false;
  swapClaimOrder() {
    // disable claim swapping if its for the survivor and they are already collecting
    if (this.isSurvivorForClient && this.clientAlreadyClaiming || !this.isSurvivorForClient && this.spouseAlreadyClaiming) {
      return;
    }

    this.swapClaimWasToggled = true;

    if(this.isSurvivorForClient){
      this.isSurvivorBenefitFirstClaim = !this.isSurvivorBenefitFirstClaim;
      this.adjustDesiredForm.get('swappedClaim').patchValue(!this.isSurvivorBenefitFirstClaim);
      console.log('this.isSurvivorBenefitFirstClaim 01', this.isSurvivorBenefitFirstClaim);
      //client widow making
      let clientAge = this.calculateAge(this.data.client.DOB);
      let minClaimAge = clientAge > 62 ? clientAge : 62; 
      //this.adjustDesiredForm.get('swappedClaim').patchValue(this.isSurvivorBenefitFirstClaim);
      this.adjustDesiredForm.get('clientAgeYears').reset();
      this.adjustDesiredForm.get('survivorSwitchAgeYears').reset();
      this.adjustDesiredForm.get('clientAgeMonths').reset();
      this.adjustDesiredForm.get('clientAgeMonths').updateValueAndValidity();
      this.adjustDesiredForm.get("survivorSwitchAgeMonths").reset();
      this.adjustDesiredForm.get("survivorSwitchAgeMonths").updateValueAndValidity();

      if(this.isSurvivorBenefitFirstClaim){
        this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.required, Validators.min(minClaimAge), Validators.max(70)]);
      } else {
        this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
      }

      this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();

      if(this.isSurvivorBenefitFirstClaim){
        this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
        this.adjustDesiredForm.get("survivorSwitchAgeMonths").reset();
        this.adjustDesiredForm.get("survivorSwitchAgeMonths").clearValidators();
        this.adjustDesiredForm.get("survivorSwitchAgeMonths").updateValueAndValidity();
      } else {
        this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.required, Validators.min(minClaimAge), Validators.max(70)]);
      }
      
      this.adjustDesiredForm.get("survivorSwitchAgeYears").updateValueAndValidity();

    } else {
      this.isSpouseSurvivorBenefitFirstClaim = !this.isSpouseSurvivorBenefitFirstClaim;
      this.adjustDesiredForm.get('swappedClaim').patchValue(!this.isSpouseSurvivorBenefitFirstClaim);
      console.log('this.isSpouseSurvivorBenefitFirstClaim 02', this.isSpouseSurvivorBenefitFirstClaim);
      //spouse widow making
      let spouseAge = this.calculateAge(this.data.clientProfile.Spouses[0].dob);
      let minClaimAge = spouseAge > 62 ? spouseAge : 62; 
      //this.adjustDesiredForm.get('swappedClaim').patchValue(this.isSpouseSurvivorBenefitFirstClaim);
      this.adjustDesiredForm.get('spouseAgeYears').reset();
      this.adjustDesiredForm.get('survivorSwitchAgeYears').reset();
      this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').reset();
      this.adjustDesiredForm.get('spouseAgeMonths').reset();
      this.adjustDesiredForm.get('spouseAgeMonths').updateValueAndValidity();
      this.adjustDesiredForm.get("survivorSwitchAgeMonths").reset();
      this.adjustDesiredForm.get('spouseSurvivorSwitchAgeMonths').reset();
      this.adjustDesiredForm.get("spouseSurvivorSwitchAgeMonths").updateValueAndValidity();
      if(this.isSpouseSurvivorBenefitFirstClaim){
        this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.required, Validators.min(minClaimAge), Validators.max(70)]);
      } else {
        this.adjustDesiredForm.get('spouseAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
      }
      this.adjustDesiredForm.get('spouseAgeYears').updateValueAndValidity();

      if(this.isSpouseSurvivorBenefitFirstClaim){
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
      } else {
        this.adjustDesiredForm.get('spouseSurvivorSwitchAgeYears').setValidators([Validators.required, Validators.min(minClaimAge), Validators.max(70)]);
      }
      this.adjustDesiredForm.get("spouseSurvivorSwitchAgeYears").updateValueAndValidity();
    }

    // if (this.isSurvivorBenefitFirstClaim) {
    //   this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
    //   this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
    //   this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
    //   this.adjustDesiredForm.get("survivorSwitchAgeYears").updateValueAndValidity(); 
    // } else {
    //   this.adjustDesiredForm.get('survivorSwitchAgeYears').setValidators([Validators.min(minClaimAge), Validators.max(70)]);
    //   this.adjustDesiredForm.get("survivorSwitchAgeYears").updateValueAndValidity(); 
    //   this.adjustDesiredForm.get('clientAgeYears').setValidators([Validators.min(minClaimAge+1), Validators.max(70)]);
    //   this.adjustDesiredForm.get('clientAgeYears').updateValueAndValidity();
    // }

  }
}
